// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file kss.proto (package kss, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file kss.proto.
 */
export const file_kss: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message kss.Empty
 */
export type Empty = Message<"kss.Empty"> & {
};

/**
 * Describes the message kss.Empty.
 * Use `create(EmptySchema)` to create a new message.
 */
export const EmptySchema: GenMessage<Empty> = /*@__PURE__*/
  messageDesc(file_kss, 0);

/**
 * @generated from message kss.ValidityResponse
 */
export type ValidityResponse = Message<"kss.ValidityResponse"> & {
  /**
   * @generated from field: bool isValid = 1;
   */
  isValid: boolean;
};

/**
 * Describes the message kss.ValidityResponse.
 * Use `create(ValidityResponseSchema)` to create a new message.
 */
export const ValidityResponseSchema: GenMessage<ValidityResponse> = /*@__PURE__*/
  messageDesc(file_kss, 1);

/**
 * @generated from message kss.AggregatedUnitCountData
 */
export type AggregatedUnitCountData = Message<"kss.AggregatedUnitCountData"> & {
  /**
   * @generated from field: uint32 total = 1;
   */
  total: number;

  /**
   * @generated from field: uint32 rentable = 2;
   */
  rentable: number;

  /**
   * @generated from field: uint32 rented = 3;
   */
  rented: number;

  /**
   * @generated from field: uint32 rented_28d = 4;
   */
  rented28d: number;

  /**
   * @generated from field: uint32 reserved = 5;
   */
  reserved: number;

  /**
   * @generated from field: uint32 occupied = 6;
   */
  occupied: number;

  /**
   * @generated from field: uint32 vacant = 7;
   */
  vacant: number;

  /**
   * @generated from field: uint32 repair = 8;
   */
  repair: number;

  /**
   * @generated from field: uint32 company = 9;
   */
  company: number;

  /**
   * @generated from field: uint32 move_in = 10;
   */
  moveIn: number;

  /**
   * @generated from field: uint32 move_out = 11;
   */
  moveOut: number;
};

/**
 * Describes the message kss.AggregatedUnitCountData.
 * Use `create(AggregatedUnitCountDataSchema)` to create a new message.
 */
export const AggregatedUnitCountDataSchema: GenMessage<AggregatedUnitCountData> = /*@__PURE__*/
  messageDesc(file_kss, 2);

/**
 * @generated from message kss.AggregatedUnitSqmData
 */
export type AggregatedUnitSqmData = Message<"kss.AggregatedUnitSqmData"> & {
  /**
   * @generated from field: double total = 1;
   */
  total: number;

  /**
   * @generated from field: double rentable = 2;
   */
  rentable: number;

  /**
   * @generated from field: double rented = 3;
   */
  rented: number;

  /**
   * @generated from field: double rented_28d = 4;
   */
  rented28d: number;

  /**
   * @generated from field: double reserved = 5;
   */
  reserved: number;

  /**
   * @generated from field: double occupied = 6;
   */
  occupied: number;

  /**
   * @generated from field: double vacant = 7;
   */
  vacant: number;

  /**
   * @generated from field: double repair = 8;
   */
  repair: number;

  /**
   * @generated from field: double company = 9;
   */
  company: number;

  /**
   * @generated from field: double move_in = 10;
   */
  moveIn: number;

  /**
   * @generated from field: double move_out = 11;
   */
  moveOut: number;
};

/**
 * Describes the message kss.AggregatedUnitSqmData.
 * Use `create(AggregatedUnitSqmDataSchema)` to create a new message.
 */
export const AggregatedUnitSqmDataSchema: GenMessage<AggregatedUnitSqmData> = /*@__PURE__*/
  messageDesc(file_kss, 3);

/**
 * @generated from message kss.AggregatedData
 */
export type AggregatedData = Message<"kss.AggregatedData"> & {
  /**
   * @generated from field: kss.AggregatedUnitCountData units = 1;
   */
  units?: AggregatedUnitCountData | undefined;

  /**
   * @generated from field: kss.AggregatedUnitSqmData sqm = 2;
   */
  sqm?: AggregatedUnitSqmData | undefined;

  /**
   * Rents
   *
   * @generated from field: double occupied_rent = 3;
   */
  occupiedRent: number;

  /**
   * @generated from field: double occupied_min_rent = 4;
   */
  occupiedMinRent: number;

  /**
   * @generated from field: double occupied_max_rent = 5;
   */
  occupiedMaxRent: number;

  /**
   * @generated from field: double street_rent = 6;
   */
  streetRent: number;

  /**
   * @generated from field: double competitor_rent = 7;
   */
  competitorRent: number;

  /**
   * @generated from field: double competitor_min_rent = 8;
   */
  competitorMinRent: number;

  /**
   * @generated from field: double competitor_max_rent = 9;
   */
  competitorMaxRent: number;

  /**
   * @generated from field: double vacant_rent = 10;
   */
  vacantRent: number;

  /**
   * @generated from field: double recommended_rent = 11;
   */
  recommendedRent: number;

  /**
   * @generated from field: double rule_rent = 12;
   */
  ruleRent: number;

  /**
   * @generated from field: double move_in_rent = 13;
   */
  moveInRent: number;

  /**
   * @generated from field: double move_in_rate = 14;
   */
  moveInRate: number;

  /**
   * @generated from field: double move_out_rent = 15;
   */
  moveOutRent: number;

  /**
   * @generated from field: double move_out_rate = 16;
   */
  moveOutRate: number;

  /**
   * Rates
   *
   * @generated from field: double occupied_rate = 17;
   */
  occupiedRate: number;

  /**
   * @generated from field: double occupied_min_rate = 18;
   */
  occupiedMinRate: number;

  /**
   * @generated from field: double occupied_max_rate = 19;
   */
  occupiedMaxRate: number;

  /**
   * @generated from field: double street_rate = 20;
   */
  streetRate: number;

  /**
   * @generated from field: double competitor_rate = 21;
   */
  competitorRate: number;

  /**
   * @generated from field: double competitor_min_rate = 22;
   */
  competitorMinRate: number;

  /**
   * @generated from field: double competitor_max_rate = 23;
   */
  competitorMaxRate: number;

  /**
   * @generated from field: double recommended_rate = 24;
   */
  recommendedRate: number;

  /**
   * @generated from field: double rule_rate = 25;
   */
  ruleRate: number;

  /**
   * @generated from field: uint32 occupancy_units_7d = 26;
   */
  occupancyUnits7d: number;

  /**
   * @generated from field: uint32 occupancy_units_28d = 27;
   */
  occupancyUnits28d: number;

  /**
   * @generated from field: uint32 occupancy_units_1y = 28;
   */
  occupancyUnits1y: number;

  /**
   * @generated from field: double occupancy_sqm_7d = 29;
   */
  occupancySqm7d: number;

  /**
   * @generated from field: double occupancy_sqm_28d = 30;
   */
  occupancySqm28d: number;

  /**
   * @generated from field: double occupancy_sqm_1y = 31;
   */
  occupancySqm1y: number;

  /**
   * @generated from field: uint32 rentable_units_7d = 32;
   */
  rentableUnits7d: number;

  /**
   * @generated from field: uint32 rentable_units_28d = 33;
   */
  rentableUnits28d: number;

  /**
   * @generated from field: uint32 rentable_units_1y = 34;
   */
  rentableUnits1y: number;

  /**
   * @generated from field: double rentable_sqm_7d = 35;
   */
  rentableSqm7d: number;

  /**
   * @generated from field: double rentable_sqm_28d = 36;
   */
  rentableSqm28d: number;

  /**
   * @generated from field: double rentable_sqm_1y = 37;
   */
  rentableSqm1y: number;
};

/**
 * Describes the message kss.AggregatedData.
 * Use `create(AggregatedDataSchema)` to create a new message.
 */
export const AggregatedDataSchema: GenMessage<AggregatedData> = /*@__PURE__*/
  messageDesc(file_kss, 4);

/**
 * Changed to a map since it's easier to work with.
 *
 * @generated from message kss.AllAggregatedDataResponse
 */
export type AllAggregatedDataResponse = Message<"kss.AllAggregatedDataResponse"> & {
  /**
   * @generated from field: map<string, kss.AggregatedData> data = 1;
   */
  data: { [key: string]: AggregatedData };

  /**
   * @generated from field: int64 processing_date = 2;
   */
  processingDate: bigint;
};

/**
 * Describes the message kss.AllAggregatedDataResponse.
 * Use `create(AllAggregatedDataResponseSchema)` to create a new message.
 */
export const AllAggregatedDataResponseSchema: GenMessage<AllAggregatedDataResponse> = /*@__PURE__*/
  messageDesc(file_kss, 5);

/**
 * @generated from message kss.SiteRequest
 */
export type SiteRequest = Message<"kss.SiteRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message kss.SiteRequest.
 * Use `create(SiteRequestSchema)` to create a new message.
 */
export const SiteRequestSchema: GenMessage<SiteRequest> = /*@__PURE__*/
  messageDesc(file_kss, 6);

/**
 * @generated from message kss.SiteResponse
 */
export type SiteResponse = Message<"kss.SiteResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string address = 3;
   */
  address: string;

  /**
   * @generated from field: string zip = 4;
   */
  zip: string;

  /**
   * @generated from field: string region = 5;
   */
  region: string;

  /**
   * @generated from field: string city = 6;
   */
  city: string;

  /**
   * @generated from field: string state = 7;
   */
  state: string;

  /**
   * @generated from field: string country = 8;
   */
  country: string;

  /**
   * @generated from field: double longitude = 9;
   */
  longitude: number;

  /**
   * @generated from field: double latitude = 10;
   */
  latitude: number;

  /**
   * @generated from field: string operation_started_on = 11;
   */
  operationStartedOn: string;
};

/**
 * Describes the message kss.SiteResponse.
 * Use `create(SiteResponseSchema)` to create a new message.
 */
export const SiteResponseSchema: GenMessage<SiteResponse> = /*@__PURE__*/
  messageDesc(file_kss, 7);

/**
 * NOTE: We cannot use 'optional' here as it is a experimental feature for proto3,
 * and is not supported by the grpc library for the UI. Instead, we treat an empty string
 * as a null for these values.
 *
 * @generated from message kss.UnitTypesRequest
 */
export type UnitTypesRequest = Message<"kss.UnitTypesRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string unit_group = 2;
   */
  unitGroup: string;

  /**
   * @generated from field: string unit_type_id = 3;
   */
  unitTypeId: string;
};

/**
 * Describes the message kss.UnitTypesRequest.
 * Use `create(UnitTypesRequestSchema)` to create a new message.
 */
export const UnitTypesRequestSchema: GenMessage<UnitTypesRequest> = /*@__PURE__*/
  messageDesc(file_kss, 8);

/**
 * @generated from message kss.UnitType
 */
export type UnitType = Message<"kss.UnitType"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string site_id = 3;
   */
  siteId: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string state = 5;
   */
  state: string;

  /**
   * @generated from field: string country = 6;
   */
  country: string;

  /**
   * @generated from field: float length = 7;
   */
  length: number;

  /**
   * @generated from field: float width = 8;
   */
  width: number;

  /**
   * @generated from field: float area = 9;
   */
  area: number;

  /**
   * @generated from field: string size_category = 10;
   */
  sizeCategory: string;

  /**
   * @generated from field: string unit_category = 11;
   */
  unitCategory: string;

  /**
   * @generated from field: string unit_group = 12;
   */
  unitGroup: string;

  /**
   * @generated from field: bool show_online = 13;
   */
  showOnline: boolean;

  /**
   * @generated from field: bool hot_deal = 14;
   */
  hotDeal: boolean;
};

/**
 * Describes the message kss.UnitType.
 * Use `create(UnitTypeSchema)` to create a new message.
 */
export const UnitTypeSchema: GenMessage<UnitType> = /*@__PURE__*/
  messageDesc(file_kss, 9);

/**
 * @generated from message kss.UnitTypesResponse
 */
export type UnitTypesResponse = Message<"kss.UnitTypesResponse"> & {
  /**
   * @generated from field: repeated kss.UnitType unit_types = 1;
   */
  unitTypes: UnitType[];
};

/**
 * Describes the message kss.UnitTypesResponse.
 * Use `create(UnitTypesResponseSchema)` to create a new message.
 */
export const UnitTypesResponseSchema: GenMessage<UnitTypesResponse> = /*@__PURE__*/
  messageDesc(file_kss, 10);

/**
 * @generated from message kss.QueryColumn
 */
export type QueryColumn = Message<"kss.QueryColumn"> & {
  /**
   * @generated from oneof kss.QueryColumn.column
   */
  column: {
    /**
     * @generated from field: kss.SnapshotColumn snapshot = 1;
     */
    value: SnapshotColumn;
    case: "snapshot";
  } | {
    /**
     * @generated from field: kss.ForecastColumn forecast = 2;
     */
    value: ForecastColumn;
    case: "forecast";
  } | {
    /**
     * @generated from field: kss.HistoricalForecastColumn hist_forecast = 3;
     */
    value: HistoricalForecastColumn;
    case: "histForecast";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message kss.QueryColumn.
 * Use `create(QueryColumnSchema)` to create a new message.
 */
export const QueryColumnSchema: GenMessage<QueryColumn> = /*@__PURE__*/
  messageDesc(file_kss, 11);

/**
 * @generated from message kss.GetTimeseriesRequest
 */
export type GetTimeseriesRequest = Message<"kss.GetTimeseriesRequest"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * @generated from field: int64 offset_days = 2;
   */
  offsetDays: bigint;

  /**
   * @generated from field: kss.QueryColumn column = 3;
   */
  column?: QueryColumn | undefined;
};

/**
 * Describes the message kss.GetTimeseriesRequest.
 * Use `create(GetTimeseriesRequestSchema)` to create a new message.
 */
export const GetTimeseriesRequestSchema: GenMessage<GetTimeseriesRequest> = /*@__PURE__*/
  messageDesc(file_kss, 12);

/**
 * @generated from message kss.TimeSeriesEntry
 */
export type TimeSeriesEntry = Message<"kss.TimeSeriesEntry"> & {
  /**
   * @generated from field: int64 x = 1;
   */
  x: bigint;

  /**
   * @generated from field: double y = 2;
   */
  y: number;
};

/**
 * Describes the message kss.TimeSeriesEntry.
 * Use `create(TimeSeriesEntrySchema)` to create a new message.
 */
export const TimeSeriesEntrySchema: GenMessage<TimeSeriesEntry> = /*@__PURE__*/
  messageDesc(file_kss, 13);

/**
 * @generated from message kss.GetTimeseriesResponse
 */
export type GetTimeseriesResponse = Message<"kss.GetTimeseriesResponse"> & {
  /**
   * @generated from field: repeated kss.TimeSeriesEntry data = 1;
   */
  data: TimeSeriesEntry[];
};

/**
 * Describes the message kss.GetTimeseriesResponse.
 * Use `create(GetTimeseriesResponseSchema)` to create a new message.
 */
export const GetTimeseriesResponseSchema: GenMessage<GetTimeseriesResponse> = /*@__PURE__*/
  messageDesc(file_kss, 14);

/**
 * @generated from message kss.SnapshotColumnAndOffset
 */
export type SnapshotColumnAndOffset = Message<"kss.SnapshotColumnAndOffset"> & {
  /**
   * @generated from field: kss.SnapshotColumn column = 1;
   */
  column: SnapshotColumn;

  /**
   * @generated from field: int64 offset_days = 2;
   */
  offsetDays: bigint;
};

/**
 * Describes the message kss.SnapshotColumnAndOffset.
 * Use `create(SnapshotColumnAndOffsetSchema)` to create a new message.
 */
export const SnapshotColumnAndOffsetSchema: GenMessage<SnapshotColumnAndOffset> = /*@__PURE__*/
  messageDesc(file_kss, 15);

/**
 * @generated from message kss.ForecastColumnAndOffset
 */
export type ForecastColumnAndOffset = Message<"kss.ForecastColumnAndOffset"> & {
  /**
   * @generated from field: kss.ForecastColumn column = 1;
   */
  column: ForecastColumn;

  /**
   * @generated from field: int64 offset_days = 2;
   */
  offsetDays: bigint;
};

/**
 * Describes the message kss.ForecastColumnAndOffset.
 * Use `create(ForecastColumnAndOffsetSchema)` to create a new message.
 */
export const ForecastColumnAndOffsetSchema: GenMessage<ForecastColumnAndOffset> = /*@__PURE__*/
  messageDesc(file_kss, 16);

/**
 * @generated from message kss.HistoricalForecastColumnAndOffset
 */
export type HistoricalForecastColumnAndOffset = Message<"kss.HistoricalForecastColumnAndOffset"> & {
  /**
   * @generated from field: kss.HistoricalForecastColumn column = 1;
   */
  column: HistoricalForecastColumn;

  /**
   * @generated from field: int64 offset_days = 2;
   */
  offsetDays: bigint;
};

/**
 * Describes the message kss.HistoricalForecastColumnAndOffset.
 * Use `create(HistoricalForecastColumnAndOffsetSchema)` to create a new message.
 */
export const HistoricalForecastColumnAndOffsetSchema: GenMessage<HistoricalForecastColumnAndOffset> = /*@__PURE__*/
  messageDesc(file_kss, 17);

/**
 * @generated from message kss.SnapshotColumnArray
 */
export type SnapshotColumnArray = Message<"kss.SnapshotColumnArray"> & {
  /**
   * @generated from field: repeated kss.SnapshotColumnAndOffset column_and_offset = 1;
   */
  columnAndOffset: SnapshotColumnAndOffset[];
};

/**
 * Describes the message kss.SnapshotColumnArray.
 * Use `create(SnapshotColumnArraySchema)` to create a new message.
 */
export const SnapshotColumnArraySchema: GenMessage<SnapshotColumnArray> = /*@__PURE__*/
  messageDesc(file_kss, 18);

/**
 * @generated from message kss.ForecastColumnArray
 */
export type ForecastColumnArray = Message<"kss.ForecastColumnArray"> & {
  /**
   * @generated from field: repeated kss.ForecastColumnAndOffset column_and_offset = 1;
   */
  columnAndOffset: ForecastColumnAndOffset[];
};

/**
 * Describes the message kss.ForecastColumnArray.
 * Use `create(ForecastColumnArraySchema)` to create a new message.
 */
export const ForecastColumnArraySchema: GenMessage<ForecastColumnArray> = /*@__PURE__*/
  messageDesc(file_kss, 19);

/**
 * @generated from message kss.HistoricalForecastColumnArray
 */
export type HistoricalForecastColumnArray = Message<"kss.HistoricalForecastColumnArray"> & {
  /**
   * @generated from field: repeated kss.HistoricalForecastColumnAndOffset column_and_offset = 1;
   */
  columnAndOffset: HistoricalForecastColumnAndOffset[];
};

/**
 * Describes the message kss.HistoricalForecastColumnArray.
 * Use `create(HistoricalForecastColumnArraySchema)` to create a new message.
 */
export const HistoricalForecastColumnArraySchema: GenMessage<HistoricalForecastColumnArray> = /*@__PURE__*/
  messageDesc(file_kss, 20);

/**
 * @generated from message kss.GetManySnapshotRequest
 */
export type GetManySnapshotRequest = Message<"kss.GetManySnapshotRequest"> & {
  /**
   * @generated from field: int64 window_days = 1;
   */
  windowDays: bigint;

  /**
   * @generated from field: map<string, kss.SnapshotColumnArray> path_to_column = 2;
   */
  pathToColumn: { [key: string]: SnapshotColumnArray };
};

/**
 * Describes the message kss.GetManySnapshotRequest.
 * Use `create(GetManySnapshotRequestSchema)` to create a new message.
 */
export const GetManySnapshotRequestSchema: GenMessage<GetManySnapshotRequest> = /*@__PURE__*/
  messageDesc(file_kss, 21);

/**
 * @generated from message kss.GetManyForecastRequest
 */
export type GetManyForecastRequest = Message<"kss.GetManyForecastRequest"> & {
  /**
   * @generated from field: map<string, kss.ForecastColumnArray> path_to_column = 2;
   */
  pathToColumn: { [key: string]: ForecastColumnArray };
};

/**
 * Describes the message kss.GetManyForecastRequest.
 * Use `create(GetManyForecastRequestSchema)` to create a new message.
 */
export const GetManyForecastRequestSchema: GenMessage<GetManyForecastRequest> = /*@__PURE__*/
  messageDesc(file_kss, 22);

/**
 * @generated from message kss.GetManyHistoricalForecastRequest
 */
export type GetManyHistoricalForecastRequest = Message<"kss.GetManyHistoricalForecastRequest"> & {
  /**
   * @generated from field: map<string, kss.HistoricalForecastColumnArray> path_to_column = 2;
   */
  pathToColumn: { [key: string]: HistoricalForecastColumnArray };
};

/**
 * Describes the message kss.GetManyHistoricalForecastRequest.
 * Use `create(GetManyHistoricalForecastRequestSchema)` to create a new message.
 */
export const GetManyHistoricalForecastRequestSchema: GenMessage<GetManyHistoricalForecastRequest> = /*@__PURE__*/
  messageDesc(file_kss, 23);

/**
 * The response here will basically be a map of path => array of TimeSeriesEntry
 *
 * @generated from message kss.GetManyResponse
 */
export type GetManyResponse = Message<"kss.GetManyResponse"> & {
  /**
   * @generated from field: map<string, kss.GetTimeseriesResponse> data = 1;
   */
  data: { [key: string]: GetTimeseriesResponse };
};

/**
 * Describes the message kss.GetManyResponse.
 * Use `create(GetManyResponseSchema)` to create a new message.
 */
export const GetManyResponseSchema: GenMessage<GetManyResponse> = /*@__PURE__*/
  messageDesc(file_kss, 24);

/**
 * @generated from message kss.WtfRecord
 */
export type WtfRecord = Message<"kss.WtfRecord"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: int64 processed_on = 2;
   */
  processedOn: bigint;

  /**
   * @generated from field: kss.WtfType wtf = 3;
   */
  wtf: WtfType;

  /**
   * @generated from field: repeated kss.WtfOutputVariable variables = 4;
   */
  variables: WtfOutputVariable[];
};

/**
 * Describes the message kss.WtfRecord.
 * Use `create(WtfRecordSchema)` to create a new message.
 */
export const WtfRecordSchema: GenMessage<WtfRecord> = /*@__PURE__*/
  messageDesc(file_kss, 25);

/**
 * @generated from message kss.WtfOutputVariable
 */
export type WtfOutputVariable = Message<"kss.WtfOutputVariable"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: double value = 2;
   */
  value: number;

  /**
   * @generated from field: double min_value = 3;
   */
  minValue: number;

  /**
   * @generated from field: double max_value = 4;
   */
  maxValue: number;
};

/**
 * Describes the message kss.WtfOutputVariable.
 * Use `create(WtfOutputVariableSchema)` to create a new message.
 */
export const WtfOutputVariableSchema: GenMessage<WtfOutputVariable> = /*@__PURE__*/
  messageDesc(file_kss, 26);

/**
 * @generated from message kss.WtfResponse
 */
export type WtfResponse = Message<"kss.WtfResponse"> & {
  /**
   * @generated from field: repeated kss.WtfRecord records = 1;
   */
  records: WtfRecord[];
};

/**
 * Describes the message kss.WtfResponse.
 * Use `create(WtfResponseSchema)` to create a new message.
 */
export const WtfResponseSchema: GenMessage<WtfResponse> = /*@__PURE__*/
  messageDesc(file_kss, 27);

/**
 * @generated from message kss.SiteGeoRequest
 */
export type SiteGeoRequest = Message<"kss.SiteGeoRequest"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;
};

/**
 * Describes the message kss.SiteGeoRequest.
 * Use `create(SiteGeoRequestSchema)` to create a new message.
 */
export const SiteGeoRequestSchema: GenMessage<SiteGeoRequest> = /*@__PURE__*/
  messageDesc(file_kss, 28);

/**
 * @generated from message kss.GeoData
 */
export type GeoData = Message<"kss.GeoData"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: double lat = 2;
   */
  lat: number;

  /**
   * @generated from field: double long = 3;
   */
  long: number;

  /**
   * 0 if it is a kss store, or the distance for a competitor
   *
   * @generated from field: double distance = 4;
   */
  distance: number;

  /**
   * @generated from field: string address = 5;
   */
  address: string;

  /**
   * @generated from field: string zip = 6;
   */
  zip: string;

  /**
   * @generated from field: string city = 7;
   */
  city: string;
};

/**
 * Describes the message kss.GeoData.
 * Use `create(GeoDataSchema)` to create a new message.
 */
export const GeoDataSchema: GenMessage<GeoData> = /*@__PURE__*/
  messageDesc(file_kss, 29);

/**
 * @generated from message kss.GeoKSS
 */
export type GeoKSS = Message<"kss.GeoKSS"> & {
  /**
   * @generated from field: kss.GeoData data = 1;
   */
  data?: GeoData | undefined;

  /**
   * key is a unit type
   *
   * @generated from field: map<string, double> rents = 8;
   */
  rents: { [key: string]: number };
};

/**
 * Describes the message kss.GeoKSS.
 * Use `create(GeoKSSSchema)` to create a new message.
 */
export const GeoKSSSchema: GenMessage<GeoKSS> = /*@__PURE__*/
  messageDesc(file_kss, 30);

/**
 * @generated from message kss.GeoCompetitorRentDate
 */
export type GeoCompetitorRentDate = Message<"kss.GeoCompetitorRentDate"> & {
  /**
   * @generated from field: double minimum = 1;
   */
  minimum: number;

  /**
   * @generated from field: double mean = 2;
   */
  mean: number;

  /**
   * @generated from field: double maximum = 3;
   */
  maximum: number;

  /**
   * @generated from field: string min_date = 4;
   */
  minDate: string;

  /**
   * @generated from field: string max_date = 5;
   */
  maxDate: string;
};

/**
 * Describes the message kss.GeoCompetitorRentDate.
 * Use `create(GeoCompetitorRentDateSchema)` to create a new message.
 */
export const GeoCompetitorRentDateSchema: GenMessage<GeoCompetitorRentDate> = /*@__PURE__*/
  messageDesc(file_kss, 31);

/**
 * @generated from message kss.GeoCompetitor
 */
export type GeoCompetitor = Message<"kss.GeoCompetitor"> & {
  /**
   * @generated from field: kss.GeoData data = 1;
   */
  data?: GeoData | undefined;

  /**
   * @generated from field: map<string, kss.GeoCompetitorRentDate> rents = 2;
   */
  rents: { [key: string]: GeoCompetitorRentDate };

  /**
   * @generated from field: int32 competitor_store_id = 3;
   */
  competitorStoreId: number;
};

/**
 * Describes the message kss.GeoCompetitor.
 * Use `create(GeoCompetitorSchema)` to create a new message.
 */
export const GeoCompetitorSchema: GenMessage<GeoCompetitor> = /*@__PURE__*/
  messageDesc(file_kss, 32);

/**
 * @generated from message kss.GeoCompetitorList
 */
export type GeoCompetitorList = Message<"kss.GeoCompetitorList"> & {
  /**
   * @generated from field: repeated kss.GeoCompetitor competitors = 1;
   */
  competitors: GeoCompetitor[];
};

/**
 * Describes the message kss.GeoCompetitorList.
 * Use `create(GeoCompetitorListSchema)` to create a new message.
 */
export const GeoCompetitorListSchema: GenMessage<GeoCompetitorList> = /*@__PURE__*/
  messageDesc(file_kss, 33);

/**
 * key is a site
 *
 * @generated from message kss.SiteGeoResponse
 */
export type SiteGeoResponse = Message<"kss.SiteGeoResponse"> & {
  /**
   * @generated from field: map<string, kss.GeoKSS> kss_data = 1;
   */
  kssData: { [key: string]: GeoKSS };

  /**
   * @generated from field: map<string, kss.GeoCompetitorList> competitor_data = 2;
   */
  competitorData: { [key: string]: GeoCompetitorList };
};

/**
 * Describes the message kss.SiteGeoResponse.
 * Use `create(SiteGeoResponseSchema)` to create a new message.
 */
export const SiteGeoResponseSchema: GenMessage<SiteGeoResponse> = /*@__PURE__*/
  messageDesc(file_kss, 34);

/**
 * @generated from message kss.PriceChange
 */
export type PriceChange = Message<"kss.PriceChange"> & {
  /**
   * @generated from field: string unit_type_id = 1;
   */
  unitTypeId: string;

  /**
   * @generated from field: double current_price = 2;
   */
  currentPrice: number;

  /**
   * @generated from field: double recommended_price = 3;
   */
  recommendedPrice: number;

  /**
   * @generated from field: double rule_based_price = 4;
   */
  ruleBasedPrice: number;

  /**
   * @generated from field: double manual_price = 5;
   */
  manualPrice: number;

  /**
   * @generated from field: double final_price = 6;
   */
  finalPrice: number;

  /**
   * @generated from field: kss.PriceChangeStatus status = 7;
   */
  status: PriceChangeStatus;

  /**
   * @generated from field: kss.PriceChangeSource choice = 8;
   */
  choice: PriceChangeSource;

  /**
   * @generated from field: string recommended_price_reason = 9;
   */
  recommendedPriceReason: string;

  /**
   * @generated from field: optional string date_override_expires = 10;
   */
  dateOverrideExpires?: string | undefined;
};

/**
 * Describes the message kss.PriceChange.
 * Use `create(PriceChangeSchema)` to create a new message.
 */
export const PriceChangeSchema: GenMessage<PriceChange> = /*@__PURE__*/
  messageDesc(file_kss, 35);

/**
 * @generated from message kss.PriceChangeResponse
 */
export type PriceChangeResponse = Message<"kss.PriceChangeResponse"> & {
  /**
   * @generated from field: map<string, kss.PriceChange> changes = 1;
   */
  changes: { [key: string]: PriceChange };
};

/**
 * Describes the message kss.PriceChangeResponse.
 * Use `create(PriceChangeResponseSchema)` to create a new message.
 */
export const PriceChangeResponseSchema: GenMessage<PriceChangeResponse> = /*@__PURE__*/
  messageDesc(file_kss, 36);

/**
 * @generated from message kss.NewPriceChange
 */
export type NewPriceChange = Message<"kss.NewPriceChange"> & {
  /**
   * @generated from field: string unit_type_id = 1;
   */
  unitTypeId: string;

  /**
   * @generated from field: double manual_price = 2;
   */
  manualPrice: number;

  /**
   * @generated from field: kss.PriceChangeSource choice = 4;
   */
  choice: PriceChangeSource;

  /**
   * @generated from field: string user_id = 5;
   */
  userId: string;

  /**
   * @generated from field: kss.PriceChangeStatus status = 6;
   */
  status: PriceChangeStatus;

  /**
   * @generated from field: optional string date_override_expires = 10;
   */
  dateOverrideExpires?: string | undefined;
};

/**
 * Describes the message kss.NewPriceChange.
 * Use `create(NewPriceChangeSchema)` to create a new message.
 */
export const NewPriceChangeSchema: GenMessage<NewPriceChange> = /*@__PURE__*/
  messageDesc(file_kss, 37);

/**
 * @generated from message kss.UpdatePriceChangesRequest
 */
export type UpdatePriceChangesRequest = Message<"kss.UpdatePriceChangesRequest"> & {
  /**
   * @generated from field: repeated kss.NewPriceChange changes = 1;
   */
  changes: NewPriceChange[];

  /**
   * @generated from field: kss.AppUser user = 2;
   */
  user?: AppUser | undefined;
};

/**
 * Describes the message kss.UpdatePriceChangesRequest.
 * Use `create(UpdatePriceChangesRequestSchema)` to create a new message.
 */
export const UpdatePriceChangesRequestSchema: GenMessage<UpdatePriceChangesRequest> = /*@__PURE__*/
  messageDesc(file_kss, 38);

/**
 * @generated from message kss.WatchPriceChangesResponse
 */
export type WatchPriceChangesResponse = Message<"kss.WatchPriceChangesResponse"> & {
  /**
   * @generated from field: kss.WatchResponseType type = 1;
   */
  type: WatchResponseType;

  /**
   * @generated from field: repeated kss.NewPriceChange changes = 2;
   */
  changes: NewPriceChange[];

  /**
   * @generated from field: kss.AppUser user = 3;
   */
  user?: AppUser | undefined;
};

/**
 * Describes the message kss.WatchPriceChangesResponse.
 * Use `create(WatchPriceChangesResponseSchema)` to create a new message.
 */
export const WatchPriceChangesResponseSchema: GenMessage<WatchPriceChangesResponse> = /*@__PURE__*/
  messageDesc(file_kss, 39);

/**
 * @generated from message kss.Flag
 */
export type Flag = Message<"kss.Flag"> & {
  /**
   * @generated from field: string main_category = 1;
   */
  mainCategory: string;

  /**
   * @generated from field: string secondary_category = 2;
   */
  secondaryCategory: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * Describes the message kss.Flag.
 * Use `create(FlagSchema)` to create a new message.
 */
export const FlagSchema: GenMessage<Flag> = /*@__PURE__*/
  messageDesc(file_kss, 40);

/**
 * @generated from message kss.GetFlagsRequest
 */
export type GetFlagsRequest = Message<"kss.GetFlagsRequest"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;
};

/**
 * Describes the message kss.GetFlagsRequest.
 * Use `create(GetFlagsRequestSchema)` to create a new message.
 */
export const GetFlagsRequestSchema: GenMessage<GetFlagsRequest> = /*@__PURE__*/
  messageDesc(file_kss, 41);

/**
 * @generated from message kss.GetFlagsResponse
 */
export type GetFlagsResponse = Message<"kss.GetFlagsResponse"> & {
  /**
   * @generated from field: repeated kss.Flag flags = 1;
   */
  flags: Flag[];
};

/**
 * Describes the message kss.GetFlagsResponse.
 * Use `create(GetFlagsResponseSchema)` to create a new message.
 */
export const GetFlagsResponseSchema: GenMessage<GetFlagsResponse> = /*@__PURE__*/
  messageDesc(file_kss, 42);

/**
 * @generated from message kss.GetManyFlagsRequest
 */
export type GetManyFlagsRequest = Message<"kss.GetManyFlagsRequest"> & {
  /**
   * @generated from field: repeated string paths = 1;
   */
  paths: string[];
};

/**
 * Describes the message kss.GetManyFlagsRequest.
 * Use `create(GetManyFlagsRequestSchema)` to create a new message.
 */
export const GetManyFlagsRequestSchema: GenMessage<GetManyFlagsRequest> = /*@__PURE__*/
  messageDesc(file_kss, 43);

/**
 * @generated from message kss.GetManyFlagsResponse
 */
export type GetManyFlagsResponse = Message<"kss.GetManyFlagsResponse"> & {
  /**
   * @generated from field: map<string, kss.GetFlagsResponse> flags = 1;
   */
  flags: { [key: string]: GetFlagsResponse };
};

/**
 * Describes the message kss.GetManyFlagsResponse.
 * Use `create(GetManyFlagsResponseSchema)` to create a new message.
 */
export const GetManyFlagsResponseSchema: GenMessage<GetManyFlagsResponse> = /*@__PURE__*/
  messageDesc(file_kss, 44);

/**
 * @generated from message kss.PipelineState
 */
export type PipelineState = Message<"kss.PipelineState"> & {
  /**
   * @generated from field: string step_name = 1;
   */
  stepName: string;

  /**
   * @generated from field: int64 started_on = 2;
   */
  startedOn: bigint;

  /**
   * @generated from field: int64 finished_on = 3;
   */
  finishedOn: bigint;

  /**
   * @generated from field: kss.PipelineStatus status = 4;
   */
  status: PipelineStatus;

  /**
   * @generated from field: int32 attempts = 5;
   */
  attempts: number;
};

/**
 * Describes the message kss.PipelineState.
 * Use `create(PipelineStateSchema)` to create a new message.
 */
export const PipelineStateSchema: GenMessage<PipelineState> = /*@__PURE__*/
  messageDesc(file_kss, 45);

/**
 * @generated from message kss.GetPipelineStatusResponse
 */
export type GetPipelineStatusResponse = Message<"kss.GetPipelineStatusResponse"> & {
  /**
   * @generated from field: kss.PipelineState data_ingestion = 1;
   */
  dataIngestion?: PipelineState | undefined;

  /**
   * @generated from field: kss.PipelineState daily_snapshot = 2;
   */
  dailySnapshot?: PipelineState | undefined;

  /**
   * @generated from field: kss.PipelineState competitor_ingest = 3;
   */
  competitorIngest?: PipelineState | undefined;

  /**
   * @generated from field: kss.PipelineState competitor_aggregation = 4;
   */
  competitorAggregation?: PipelineState | undefined;

  /**
   * @generated from field: kss.PipelineState snapshot_aggregation = 5;
   */
  snapshotAggregation?: PipelineState | undefined;

  /**
   * @generated from field: kss.PipelineState forecasting = 6;
   */
  forecasting?: PipelineState | undefined;

  /**
   * @generated from field: kss.PipelineState demand = 7;
   */
  demand?: PipelineState | undefined;

  /**
   * @generated from field: kss.PipelineState price_recommendation = 8;
   */
  priceRecommendation?: PipelineState | undefined;

  /**
   * @generated from field: kss.PipelineState price_update = 9;
   */
  priceUpdate?: PipelineState | undefined;

  /**
   * @generated from field: kss.PipelineState wtf_generation = 10;
   */
  wtfGeneration?: PipelineState | undefined;
};

/**
 * Describes the message kss.GetPipelineStatusResponse.
 * Use `create(GetPipelineStatusResponseSchema)` to create a new message.
 */
export const GetPipelineStatusResponseSchema: GenMessage<GetPipelineStatusResponse> = /*@__PURE__*/
  messageDesc(file_kss, 46);

/**
 * @generated from message kss.SiteNamesResponse
 */
export type SiteNamesResponse = Message<"kss.SiteNamesResponse"> & {
  /**
   * @generated from field: map<string, string> id_to_name = 1;
   */
  idToName: { [key: string]: string };

  /**
   * @generated from field: map<string, string> id_to_ingestion_source = 2;
   */
  idToIngestionSource: { [key: string]: string };
};

/**
 * Describes the message kss.SiteNamesResponse.
 * Use `create(SiteNamesResponseSchema)` to create a new message.
 */
export const SiteNamesResponseSchema: GenMessage<SiteNamesResponse> = /*@__PURE__*/
  messageDesc(file_kss, 47);

/**
 * @generated from message kss.SiteWhitelistResponse
 */
export type SiteWhitelistResponse = Message<"kss.SiteWhitelistResponse"> & {
  /**
   * @generated from field: repeated string whitelist = 1;
   */
  whitelist: string[];
};

/**
 * Describes the message kss.SiteWhitelistResponse.
 * Use `create(SiteWhitelistResponseSchema)` to create a new message.
 */
export const SiteWhitelistResponseSchema: GenMessage<SiteWhitelistResponse> = /*@__PURE__*/
  messageDesc(file_kss, 48);

/**
 * @generated from message kss.UnitTypeAreasResponse
 */
export type UnitTypeAreasResponse = Message<"kss.UnitTypeAreasResponse"> & {
  /**
   * @generated from field: map<string, double> unit_type_id_to_area = 1;
   */
  unitTypeIdToArea: { [key: string]: number };
};

/**
 * Describes the message kss.UnitTypeAreasResponse.
 * Use `create(UnitTypeAreasResponseSchema)` to create a new message.
 */
export const UnitTypeAreasResponseSchema: GenMessage<UnitTypeAreasResponse> = /*@__PURE__*/
  messageDesc(file_kss, 49);

/**
 * @generated from message kss.AppUser
 */
export type AppUser = Message<"kss.AppUser"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string user_id = 3;
   */
  userId: string;
};

/**
 * Describes the message kss.AppUser.
 * Use `create(AppUserSchema)` to create a new message.
 */
export const AppUserSchema: GenMessage<AppUser> = /*@__PURE__*/
  messageDesc(file_kss, 50);

/**
 * Wtf section
 *
 * @generated from message kss.WtfNewConfiguration
 */
export type WtfNewConfiguration = Message<"kss.WtfNewConfiguration"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * serialised json
   *
   * @generated from field: string configuration = 2;
   */
  configuration: string;

  /**
   * @generated from field: string user_id = 4;
   */
  userId: string;
};

/**
 * Describes the message kss.WtfNewConfiguration.
 * Use `create(WtfNewConfigurationSchema)` to create a new message.
 */
export const WtfNewConfigurationSchema: GenMessage<WtfNewConfiguration> = /*@__PURE__*/
  messageDesc(file_kss, 51);

/**
 * @generated from message kss.WtfConfiguration
 */
export type WtfConfiguration = Message<"kss.WtfConfiguration"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * serialised json
   *
   * @generated from field: string configuration = 2;
   */
  configuration: string;

  /**
   * @generated from field: bool active = 3;
   */
  active: boolean;

  /**
   * @generated from field: string user_id = 4;
   */
  userId: string;

  /**
   * @generated from field: int64 created_at = 5;
   */
  createdAt: bigint;

  /**
   * @generated from field: int64 updated_at = 6;
   */
  updatedAt: bigint;
};

/**
 * Describes the message kss.WtfConfiguration.
 * Use `create(WtfConfigurationSchema)` to create a new message.
 */
export const WtfConfigurationSchema: GenMessage<WtfConfiguration> = /*@__PURE__*/
  messageDesc(file_kss, 52);

/**
 * @generated from message kss.WtfUpdateConfiguration
 */
export type WtfUpdateConfiguration = Message<"kss.WtfUpdateConfiguration"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * serialised json
   *
   * @generated from field: string configuration = 2;
   */
  configuration: string;

  /**
   * @generated from field: bool active = 3;
   */
  active: boolean;

  /**
   * @generated from field: string user_id = 4;
   */
  userId: string;
};

/**
 * Describes the message kss.WtfUpdateConfiguration.
 * Use `create(WtfUpdateConfigurationSchema)` to create a new message.
 */
export const WtfUpdateConfigurationSchema: GenMessage<WtfUpdateConfiguration> = /*@__PURE__*/
  messageDesc(file_kss, 53);

/**
 * @generated from message kss.GetWtfInputsResponse
 */
export type GetWtfInputsResponse = Message<"kss.GetWtfInputsResponse"> & {
  /**
   * @generated from field: repeated kss.WtfInput inputs = 1;
   */
  inputs: WtfInput[];
};

/**
 * Describes the message kss.GetWtfInputsResponse.
 * Use `create(GetWtfInputsResponseSchema)` to create a new message.
 */
export const GetWtfInputsResponseSchema: GenMessage<GetWtfInputsResponse> = /*@__PURE__*/
  messageDesc(file_kss, 54);

/**
 * @generated from message kss.WtfInput
 */
export type WtfInput = Message<"kss.WtfInput"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;
};

/**
 * Describes the message kss.WtfInput.
 * Use `create(WtfInputSchema)` to create a new message.
 */
export const WtfInputSchema: GenMessage<WtfInput> = /*@__PURE__*/
  messageDesc(file_kss, 55);

/**
 * @generated from message kss.GetWtfConfigurationsResponse
 */
export type GetWtfConfigurationsResponse = Message<"kss.GetWtfConfigurationsResponse"> & {
  /**
   * @generated from field: repeated kss.WtfConfiguration configurations = 1;
   */
  configurations: WtfConfiguration[];
};

/**
 * Describes the message kss.GetWtfConfigurationsResponse.
 * Use `create(GetWtfConfigurationsResponseSchema)` to create a new message.
 */
export const GetWtfConfigurationsResponseSchema: GenMessage<GetWtfConfigurationsResponse> = /*@__PURE__*/
  messageDesc(file_kss, 56);

/**
 * @generated from message kss.CreateWtfConfigurationRequest
 */
export type CreateWtfConfigurationRequest = Message<"kss.CreateWtfConfigurationRequest"> & {
  /**
   * @generated from field: kss.WtfNewConfiguration configuration = 1;
   */
  configuration?: WtfNewConfiguration | undefined;
};

/**
 * Describes the message kss.CreateWtfConfigurationRequest.
 * Use `create(CreateWtfConfigurationRequestSchema)` to create a new message.
 */
export const CreateWtfConfigurationRequestSchema: GenMessage<CreateWtfConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_kss, 57);

/**
 * @generated from message kss.UpdateWtfConfigurationRequest
 */
export type UpdateWtfConfigurationRequest = Message<"kss.UpdateWtfConfigurationRequest"> & {
  /**
   * @generated from field: kss.WtfUpdateConfiguration configuration = 1;
   */
  configuration?: WtfUpdateConfiguration | undefined;
};

/**
 * Describes the message kss.UpdateWtfConfigurationRequest.
 * Use `create(UpdateWtfConfigurationRequestSchema)` to create a new message.
 */
export const UpdateWtfConfigurationRequestSchema: GenMessage<UpdateWtfConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_kss, 58);

/**
 * @generated from message kss.SaveWtfConfigurationRequest
 */
export type SaveWtfConfigurationRequest = Message<"kss.SaveWtfConfigurationRequest"> & {
  /**
   * @generated from field: kss.WtfConfiguration configuration = 1;
   */
  configuration?: WtfConfiguration | undefined;
};

/**
 * Describes the message kss.SaveWtfConfigurationRequest.
 * Use `create(SaveWtfConfigurationRequestSchema)` to create a new message.
 */
export const SaveWtfConfigurationRequestSchema: GenMessage<SaveWtfConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_kss, 59);

/**
 * @generated from message kss.ActivateWtfConfigurationRequest
 */
export type ActivateWtfConfigurationRequest = Message<"kss.ActivateWtfConfigurationRequest"> & {
  /**
   * @generated from field: string configuration_id = 1;
   */
  configurationId: string;
};

/**
 * Describes the message kss.ActivateWtfConfigurationRequest.
 * Use `create(ActivateWtfConfigurationRequestSchema)` to create a new message.
 */
export const ActivateWtfConfigurationRequestSchema: GenMessage<ActivateWtfConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_kss, 60);

/**
 * @generated from message kss.ArchiveWtfConfigurationRequest
 */
export type ArchiveWtfConfigurationRequest = Message<"kss.ArchiveWtfConfigurationRequest"> & {
  /**
   * @generated from field: string configuration_id = 1;
   */
  configurationId: string;
};

/**
 * Describes the message kss.ArchiveWtfConfigurationRequest.
 * Use `create(ArchiveWtfConfigurationRequestSchema)` to create a new message.
 */
export const ArchiveWtfConfigurationRequestSchema: GenMessage<ArchiveWtfConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_kss, 61);

/**
 * @generated from message kss.EvaluateWtfConfigurationRequest
 */
export type EvaluateWtfConfigurationRequest = Message<"kss.EvaluateWtfConfigurationRequest"> & {
  /**
   * @generated from field: string configuration = 1;
   */
  configuration: string;
};

/**
 * Describes the message kss.EvaluateWtfConfigurationRequest.
 * Use `create(EvaluateWtfConfigurationRequestSchema)` to create a new message.
 */
export const EvaluateWtfConfigurationRequestSchema: GenMessage<EvaluateWtfConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_kss, 62);

/**
 * @generated from message kss.ExecuteWtfConfigurationRequest
 */
export type ExecuteWtfConfigurationRequest = Message<"kss.ExecuteWtfConfigurationRequest"> & {
  /**
   * @generated from field: string configuration_id = 1;
   */
  configurationId: string;

  /**
   * @generated from field: bool save_data = 2;
   */
  saveData: boolean;
};

/**
 * Describes the message kss.ExecuteWtfConfigurationRequest.
 * Use `create(ExecuteWtfConfigurationRequestSchema)` to create a new message.
 */
export const ExecuteWtfConfigurationRequestSchema: GenMessage<ExecuteWtfConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_kss, 63);

/**
 * @generated from message kss.ValidateWtfConfigurationRequest
 */
export type ValidateWtfConfigurationRequest = Message<"kss.ValidateWtfConfigurationRequest"> & {
  /**
   * @generated from field: string configuration = 1;
   */
  configuration: string;
};

/**
 * Describes the message kss.ValidateWtfConfigurationRequest.
 * Use `create(ValidateWtfConfigurationRequestSchema)` to create a new message.
 */
export const ValidateWtfConfigurationRequestSchema: GenMessage<ValidateWtfConfigurationRequest> = /*@__PURE__*/
  messageDesc(file_kss, 64);

/**
 * @generated from message kss.CreateWtfConfigurationResponse
 */
export type CreateWtfConfigurationResponse = Message<"kss.CreateWtfConfigurationResponse"> & {
  /**
   * @generated from field: kss.WtfConfiguration configuration = 1;
   */
  configuration?: WtfConfiguration | undefined;
};

/**
 * Describes the message kss.CreateWtfConfigurationResponse.
 * Use `create(CreateWtfConfigurationResponseSchema)` to create a new message.
 */
export const CreateWtfConfigurationResponseSchema: GenMessage<CreateWtfConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_kss, 65);

/**
 * @generated from message kss.UpdateWtfConfigurationResponse
 */
export type UpdateWtfConfigurationResponse = Message<"kss.UpdateWtfConfigurationResponse"> & {
  /**
   * @generated from field: kss.WtfConfiguration configuration = 1;
   */
  configuration?: WtfConfiguration | undefined;
};

/**
 * Describes the message kss.UpdateWtfConfigurationResponse.
 * Use `create(UpdateWtfConfigurationResponseSchema)` to create a new message.
 */
export const UpdateWtfConfigurationResponseSchema: GenMessage<UpdateWtfConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_kss, 66);

/**
 * @generated from message kss.DeleteWtfConfigurationResponse
 */
export type DeleteWtfConfigurationResponse = Message<"kss.DeleteWtfConfigurationResponse"> & {
};

/**
 * Describes the message kss.DeleteWtfConfigurationResponse.
 * Use `create(DeleteWtfConfigurationResponseSchema)` to create a new message.
 */
export const DeleteWtfConfigurationResponseSchema: GenMessage<DeleteWtfConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_kss, 67);

/**
 * @generated from message kss.ValidateWtfConfigurationResponse
 */
export type ValidateWtfConfigurationResponse = Message<"kss.ValidateWtfConfigurationResponse"> & {
  /**
   * @generated from field: bool is_valid = 1;
   */
  isValid: boolean;

  /**
   * @generated from field: string error_message = 2;
   */
  errorMessage: string;
};

/**
 * Describes the message kss.ValidateWtfConfigurationResponse.
 * Use `create(ValidateWtfConfigurationResponseSchema)` to create a new message.
 */
export const ValidateWtfConfigurationResponseSchema: GenMessage<ValidateWtfConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_kss, 68);

/**
 * @generated from message kss.EvaluateWtfConfigurationResponse
 */
export type EvaluateWtfConfigurationResponse = Message<"kss.EvaluateWtfConfigurationResponse"> & {
  /**
   * @generated from field: kss.ValidateWtfConfigurationResponse validation = 1;
   */
  validation?: ValidateWtfConfigurationResponse | undefined;

  /**
   * @generated from field: repeated kss.EvaluateWtfRecord site_wtfs = 2;
   */
  siteWtfs: EvaluateWtfRecord[];
};

/**
 * Describes the message kss.EvaluateWtfConfigurationResponse.
 * Use `create(EvaluateWtfConfigurationResponseSchema)` to create a new message.
 */
export const EvaluateWtfConfigurationResponseSchema: GenMessage<EvaluateWtfConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_kss, 69);

/**
 * @generated from message kss.ExecuteWtfConfigurationResponse
 */
export type ExecuteWtfConfigurationResponse = Message<"kss.ExecuteWtfConfigurationResponse"> & {
  /**
   * @generated from field: kss.ValidateWtfConfigurationResponse validation = 1;
   */
  validation?: ValidateWtfConfigurationResponse | undefined;

  /**
   * @generated from field: repeated kss.EvaluateWtfRecord site_wtfs = 2;
   */
  siteWtfs: EvaluateWtfRecord[];
};

/**
 * Describes the message kss.ExecuteWtfConfigurationResponse.
 * Use `create(ExecuteWtfConfigurationResponseSchema)` to create a new message.
 */
export const ExecuteWtfConfigurationResponseSchema: GenMessage<ExecuteWtfConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_kss, 70);

/**
 * @generated from message kss.EvaluateWtfRecord
 */
export type EvaluateWtfRecord = Message<"kss.EvaluateWtfRecord"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: kss.WtfType wtf = 2;
   */
  wtf: WtfType;

  /**
   * @generated from field: repeated kss.WtfOutputVariable variables = 3;
   */
  variables: WtfOutputVariable[];
};

/**
 * Describes the message kss.EvaluateWtfRecord.
 * Use `create(EvaluateWtfRecordSchema)` to create a new message.
 */
export const EvaluateWtfRecordSchema: GenMessage<EvaluateWtfRecord> = /*@__PURE__*/
  messageDesc(file_kss, 71);

/**
 * @generated from message kss.ValidateWtfCompoundInputRequest
 */
export type ValidateWtfCompoundInputRequest = Message<"kss.ValidateWtfCompoundInputRequest"> & {
  /**
   * @generated from field: string expression = 1;
   */
  expression: string;
};

/**
 * Describes the message kss.ValidateWtfCompoundInputRequest.
 * Use `create(ValidateWtfCompoundInputRequestSchema)` to create a new message.
 */
export const ValidateWtfCompoundInputRequestSchema: GenMessage<ValidateWtfCompoundInputRequest> = /*@__PURE__*/
  messageDesc(file_kss, 72);

/**
 * @generated from message kss.ValidateWtfCompoundInputResponse
 */
export type ValidateWtfCompoundInputResponse = Message<"kss.ValidateWtfCompoundInputResponse"> & {
  /**
   * @generated from field: bool is_valid = 1;
   */
  isValid: boolean;

  /**
   * @generated from field: string error_message = 2;
   */
  errorMessage: string;
};

/**
 * Describes the message kss.ValidateWtfCompoundInputResponse.
 * Use `create(ValidateWtfCompoundInputResponseSchema)` to create a new message.
 */
export const ValidateWtfCompoundInputResponseSchema: GenMessage<ValidateWtfCompoundInputResponse> = /*@__PURE__*/
  messageDesc(file_kss, 73);

/**
 * @generated from message kss.UnitRentalsRequest
 */
export type UnitRentalsRequest = Message<"kss.UnitRentalsRequest"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;
};

/**
 * Describes the message kss.UnitRentalsRequest.
 * Use `create(UnitRentalsRequestSchema)` to create a new message.
 */
export const UnitRentalsRequestSchema: GenMessage<UnitRentalsRequest> = /*@__PURE__*/
  messageDesc(file_kss, 74);

/**
 * @generated from message kss.UnitRental
 */
export type UnitRental = Message<"kss.UnitRental"> & {
  /**
   * @generated from field: string state_id = 1;
   */
  stateId: string;

  /**
   * @generated from field: string site_id = 2;
   */
  siteId: string;

  /**
   * @generated from field: string unit_group_id = 3;
   */
  unitGroupId: string;

  /**
   * @generated from field: string unit_type_id = 4;
   */
  unitTypeId: string;

  /**
   * @generated from field: string unit_id = 5;
   */
  unitId: string;

  /**
   * @generated from field: string rental_id = 6;
   */
  rentalId: string;

  /**
   * @generated from field: string sales_channel = 7;
   */
  salesChannel: string;

  /**
   * @generated from field: double street_rent = 8;
   */
  streetRent: number;

  /**
   * @generated from field: double current_rent = 9;
   */
  currentRent: number;

  /**
   * @generated from field: double move_in_rent = 10;
   */
  moveInRent: number;

  /**
   * @generated from field: string move_in_date = 11;
   */
  moveInDate: string;

  /**
   * @generated from field: double discount = 13;
   */
  discount: number;

  /**
   * @generated from field: string status = 14;
   */
  status: string;

  /**
   * New
   *
   * @generated from field: bool eligible = 15;
   */
  eligible: boolean;

  /**
   * @generated from field: string account_type = 16;
   */
  accountType: string;

  /**
   * @generated from field: string last_price_change_on = 17;
   */
  lastPriceChangeOn: string;

  /**
   * @generated from field: string description = 18;
   */
  description: string;

  /**
   * @generated from field: string customer_id = 19;
   */
  customerId: string;

  /**
   * @generated from field: string customer_name = 20;
   */
  customerName: string;

  /**
   * @generated from field: int64 unit_pk = 21;
   */
  unitPk: bigint;

  /**
   * @generated from field: string start_on = 22;
   */
  startOn: string;

  /**
   * @generated from field: int32 unit_type_pk = 23;
   */
  unitTypePk: number;

  /**
   * @generated from field: string updated_at = 24;
   */
  updatedAt: string;

  /**
   * @generated from field: string snooze_until = 25;
   */
  snoozeUntil: string;

  /**
   * @generated from field: bool business = 26;
   */
  business: boolean;

  /**
   * @generated from field: bool recurring_payment = 27;
   */
  recurringPayment: boolean;
};

/**
 * Describes the message kss.UnitRental.
 * Use `create(UnitRentalSchema)` to create a new message.
 */
export const UnitRentalSchema: GenMessage<UnitRental> = /*@__PURE__*/
  messageDesc(file_kss, 75);

/**
 * @generated from message kss.UnitRentalsResponse
 */
export type UnitRentalsResponse = Message<"kss.UnitRentalsResponse"> & {
  /**
   * @generated from field: repeated kss.UnitRental data = 1;
   */
  data: UnitRental[];
};

/**
 * Describes the message kss.UnitRentalsResponse.
 * Use `create(UnitRentalsResponseSchema)` to create a new message.
 */
export const UnitRentalsResponseSchema: GenMessage<UnitRentalsResponse> = /*@__PURE__*/
  messageDesc(file_kss, 76);

/**
 * @generated from message kss.GetAllUnitRentalPriceChangesResponse
 */
export type GetAllUnitRentalPriceChangesResponse = Message<"kss.GetAllUnitRentalPriceChangesResponse"> & {
  /**
   * @generated from field: repeated kss.RentalPriceChange rentals = 1;
   */
  rentals: RentalPriceChange[];
};

/**
 * Describes the message kss.GetAllUnitRentalPriceChangesResponse.
 * Use `create(GetAllUnitRentalPriceChangesResponseSchema)` to create a new message.
 */
export const GetAllUnitRentalPriceChangesResponseSchema: GenMessage<GetAllUnitRentalPriceChangesResponse> = /*@__PURE__*/
  messageDesc(file_kss, 77);

/**
 * @generated from message kss.GetRentalPriceChangeRequest
 */
export type GetRentalPriceChangeRequest = Message<"kss.GetRentalPriceChangeRequest"> & {
  /**
   * @generated from field: string unit_id = 1;
   */
  unitId: string;
};

/**
 * Describes the message kss.GetRentalPriceChangeRequest.
 * Use `create(GetRentalPriceChangeRequestSchema)` to create a new message.
 */
export const GetRentalPriceChangeRequestSchema: GenMessage<GetRentalPriceChangeRequest> = /*@__PURE__*/
  messageDesc(file_kss, 78);

/**
 * @generated from message kss.RentalPriceChange
 */
export type RentalPriceChange = Message<"kss.RentalPriceChange"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int64 unit_pk = 2;
   */
  unitPk: bigint;

  /**
   * @generated from field: string unit_id = 3;
   */
  unitId: string;

  /**
   * @generated from field: string processed_on = 4;
   */
  processedOn: string;

  /**
   * @generated from field: kss.PriceChangeStatus status = 5;
   */
  status: PriceChangeStatus;

  /**
   * @generated from field: string increase_from = 6;
   */
  increaseFrom: string;

  /**
   * @generated from field: double current_price = 7;
   */
  currentPrice: number;

  /**
   * @generated from field: double recommended_price = 8;
   */
  recommendedPrice: number;

  /**
   * @generated from field: string recommended_price_reason = 9;
   */
  recommendedPriceReason: string;

  /**
   * @generated from field: optional int64 override_value = 10;
   */
  overrideValue?: bigint | undefined;

  /**
   * @generated from field: kss.RentalPriceChoice price_choice = 11;
   */
  priceChoice: RentalPriceChoice;

  /**
   * @generated from field: string next_recommendation_date = 12;
   */
  nextRecommendationDate: string;

  /**
   * @generated from field: string created_by = 13;
   */
  createdBy: string;

  /**
   * @generated from field: string approved_by = 14;
   */
  approvedBy: string;

  /**
   * @generated from field: string approved_at = 15;
   */
  approvedAt: string;

  /**
   * @generated from field: string saved_on_storman_at = 16;
   */
  savedOnStormanAt: string;

  /**
   * @generated from field: string storman_ref_number = 17;
   */
  stormanRefNumber: string;

  /**
   * @generated from field: string updated_at = 18;
   */
  updatedAt: string;

  /**
   * @generated from field: bool tier_constraint_hit = 19;
   */
  tierConstraintHit: boolean;
};

/**
 * Describes the message kss.RentalPriceChange.
 * Use `create(RentalPriceChangeSchema)` to create a new message.
 */
export const RentalPriceChangeSchema: GenMessage<RentalPriceChange> = /*@__PURE__*/
  messageDesc(file_kss, 79);

/**
 * @generated from message kss.RentalPriceChangeUpdate
 */
export type RentalPriceChangeUpdate = Message<"kss.RentalPriceChangeUpdate"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: kss.RentalPriceChoice choice = 2;
   */
  choice: RentalPriceChoice;

  /**
   * @generated from field: kss.PriceChangeStatus status = 3;
   */
  status: PriceChangeStatus;

  /**
   * @generated from field: optional int64 override = 4;
   */
  override?: bigint | undefined;

  /**
   * @generated from field: optional int64 snooze_months = 5;
   */
  snoozeMonths?: bigint | undefined;
};

/**
 * Describes the message kss.RentalPriceChangeUpdate.
 * Use `create(RentalPriceChangeUpdateSchema)` to create a new message.
 */
export const RentalPriceChangeUpdateSchema: GenMessage<RentalPriceChangeUpdate> = /*@__PURE__*/
  messageDesc(file_kss, 80);

/**
 * @generated from message kss.UpdateRentalPriceChangesRequest
 */
export type UpdateRentalPriceChangesRequest = Message<"kss.UpdateRentalPriceChangesRequest"> & {
  /**
   * @generated from field: string deployed_by = 1;
   */
  deployedBy: string;

  /**
   * @generated from field: repeated kss.RentalPriceChangeUpdate update = 2;
   */
  update: RentalPriceChangeUpdate[];
};

/**
 * Describes the message kss.UpdateRentalPriceChangesRequest.
 * Use `create(UpdateRentalPriceChangesRequestSchema)` to create a new message.
 */
export const UpdateRentalPriceChangesRequestSchema: GenMessage<UpdateRentalPriceChangesRequest> = /*@__PURE__*/
  messageDesc(file_kss, 81);

/**
 * @generated from message kss.UpdateRentalPriceChangesResponse
 */
export type UpdateRentalPriceChangesResponse = Message<"kss.UpdateRentalPriceChangesResponse"> & {
  /**
   * @generated from field: repeated kss.RentalPriceChange changed = 1;
   */
  changed: RentalPriceChange[];
};

/**
 * Describes the message kss.UpdateRentalPriceChangesResponse.
 * Use `create(UpdateRentalPriceChangesResponseSchema)` to create a new message.
 */
export const UpdateRentalPriceChangesResponseSchema: GenMessage<UpdateRentalPriceChangesResponse> = /*@__PURE__*/
  messageDesc(file_kss, 82);

/**
 * @generated from message kss.GlobalEcrConfigEntry
 */
export type GlobalEcrConfigEntry = Message<"kss.GlobalEcrConfigEntry"> & {
  /**
   * @generated from field: kss.EcrConfigUnitGroup unit_group = 1;
   */
  unitGroup: EcrConfigUnitGroup;

  /**
   * @generated from field: int32 first_rec_months = 2;
   */
  firstRecMonths: number;

  /**
   * @generated from field: int32 next_rec_months = 3;
   */
  nextRecMonths: number;

  /**
   * @generated from field: int32 recreate_rec_months = 4;
   */
  recreateRecMonths: number;

  /**
   * @generated from field: int32 notice_period = 5;
   */
  noticePeriod: number;

  /**
   * @generated from field: kss.DayOfWeek runs_on = 6;
   */
  runsOn: DayOfWeek;
};

/**
 * Describes the message kss.GlobalEcrConfigEntry.
 * Use `create(GlobalEcrConfigEntrySchema)` to create a new message.
 */
export const GlobalEcrConfigEntrySchema: GenMessage<GlobalEcrConfigEntry> = /*@__PURE__*/
  messageDesc(file_kss, 83);

/**
 * @generated from message kss.GlobalEcrConfig
 */
export type GlobalEcrConfig = Message<"kss.GlobalEcrConfig"> & {
  /**
   * @generated from field: repeated kss.GlobalEcrConfigEntry config = 1;
   */
  config: GlobalEcrConfigEntry[];
};

/**
 * Describes the message kss.GlobalEcrConfig.
 * Use `create(GlobalEcrConfigSchema)` to create a new message.
 */
export const GlobalEcrConfigSchema: GenMessage<GlobalEcrConfig> = /*@__PURE__*/
  messageDesc(file_kss, 84);

/**
 * @generated from message kss.ExclusionEcrConfigEntry
 */
export type ExclusionEcrConfigEntry = Message<"kss.ExclusionEcrConfigEntry"> & {
  /**
   * @generated from field: kss.EcrConfigUnitGroup unit_group = 1;
   */
  unitGroup: EcrConfigUnitGroup;

  /**
   * @generated from field: string start_on = 2;
   */
  startOn: string;

  /**
   * @generated from field: string end_on = 3;
   */
  endOn: string;

  /**
   * @generated from field: string site_id = 4;
   */
  siteId: string;
};

/**
 * Describes the message kss.ExclusionEcrConfigEntry.
 * Use `create(ExclusionEcrConfigEntrySchema)` to create a new message.
 */
export const ExclusionEcrConfigEntrySchema: GenMessage<ExclusionEcrConfigEntry> = /*@__PURE__*/
  messageDesc(file_kss, 85);

/**
 * @generated from message kss.ExclusionEcrConfig
 */
export type ExclusionEcrConfig = Message<"kss.ExclusionEcrConfig"> & {
  /**
   * @generated from field: repeated kss.ExclusionEcrConfigEntry config = 1;
   */
  config: ExclusionEcrConfigEntry[];
};

/**
 * Describes the message kss.ExclusionEcrConfig.
 * Use `create(ExclusionEcrConfigSchema)` to create a new message.
 */
export const ExclusionEcrConfigSchema: GenMessage<ExclusionEcrConfig> = /*@__PURE__*/
  messageDesc(file_kss, 86);

/**
 * @generated from message kss.TierBoundEcrConfigEntry
 */
export type TierBoundEcrConfigEntry = Message<"kss.TierBoundEcrConfigEntry"> & {
  /**
   * @generated from field: kss.EcrConfigUnitGroup unit_group = 1;
   */
  unitGroup: EcrConfigUnitGroup;

  /**
   * @generated from field: float occ_v_street_perc = 2;
   */
  occVStreetPerc: number;

  /**
   * @generated from field: float increase_bound_perc = 3;
   */
  increaseBoundPerc: number;
};

/**
 * Describes the message kss.TierBoundEcrConfigEntry.
 * Use `create(TierBoundEcrConfigEntrySchema)` to create a new message.
 */
export const TierBoundEcrConfigEntrySchema: GenMessage<TierBoundEcrConfigEntry> = /*@__PURE__*/
  messageDesc(file_kss, 87);

/**
 * @generated from message kss.TierBoundEcrConfig
 */
export type TierBoundEcrConfig = Message<"kss.TierBoundEcrConfig"> & {
  /**
   * @generated from field: repeated kss.TierBoundEcrConfigEntry config = 1;
   */
  config: TierBoundEcrConfigEntry[];
};

/**
 * Describes the message kss.TierBoundEcrConfig.
 * Use `create(TierBoundEcrConfigSchema)` to create a new message.
 */
export const TierBoundEcrConfigSchema: GenMessage<TierBoundEcrConfig> = /*@__PURE__*/
  messageDesc(file_kss, 88);

/**
 * @generated from message kss.GetRentalPriceHistoryRequest
 */
export type GetRentalPriceHistoryRequest = Message<"kss.GetRentalPriceHistoryRequest"> & {
  /**
   * @generated from field: int32 unit_pk = 1;
   */
  unitPk: number;

  /**
   * @generated from field: string rental_id = 2;
   */
  rentalId: string;
};

/**
 * Describes the message kss.GetRentalPriceHistoryRequest.
 * Use `create(GetRentalPriceHistoryRequestSchema)` to create a new message.
 */
export const GetRentalPriceHistoryRequestSchema: GenMessage<GetRentalPriceHistoryRequest> = /*@__PURE__*/
  messageDesc(file_kss, 89);

/**
 * @generated from message kss.GetRentalPriceHistoryResponse
 */
export type GetRentalPriceHistoryResponse = Message<"kss.GetRentalPriceHistoryResponse"> & {
  /**
   * @generated from field: repeated kss.TimeSeriesEntry data = 1;
   */
  data: TimeSeriesEntry[];
};

/**
 * Describes the message kss.GetRentalPriceHistoryResponse.
 * Use `create(GetRentalPriceHistoryResponseSchema)` to create a new message.
 */
export const GetRentalPriceHistoryResponseSchema: GenMessage<GetRentalPriceHistoryResponse> = /*@__PURE__*/
  messageDesc(file_kss, 90);

/**
 * @generated from message kss.CompetitorWeightEntry
 */
export type CompetitorWeightEntry = Message<"kss.CompetitorWeightEntry"> & {
  /**
   * @generated from field: string kss_site_id = 1;
   */
  kssSiteId: string;

  /**
   * @generated from field: string competitor_name = 2;
   */
  competitorName: string;

  /**
   * @generated from field: int32 kss_store_id = 3;
   */
  kssStoreId: number;

  /**
   * @generated from field: int32 competitor_store_id = 4;
   */
  competitorStoreId: number;

  /**
   * @generated from field: kss.EcrConfigUnitGroup unit_group = 5;
   */
  unitGroup: EcrConfigUnitGroup;

  /**
   * @generated from field: int32 matching_units = 6;
   */
  matchingUnits: number;

  /**
   * @generated from field: kss.CompetitorWeight competitor_weight = 7;
   */
  competitorWeight: CompetitorWeight;
};

/**
 * Describes the message kss.CompetitorWeightEntry.
 * Use `create(CompetitorWeightEntrySchema)` to create a new message.
 */
export const CompetitorWeightEntrySchema: GenMessage<CompetitorWeightEntry> = /*@__PURE__*/
  messageDesc(file_kss, 91);

/**
 * @generated from message kss.CompetitorWeightUpdate
 */
export type CompetitorWeightUpdate = Message<"kss.CompetitorWeightUpdate"> & {
  /**
   * @generated from field: int32 kss_store_id = 1;
   */
  kssStoreId: number;

  /**
   * @generated from field: int32 competitor_store_id = 2;
   */
  competitorStoreId: number;

  /**
   * @generated from field: kss.EcrConfigUnitGroup unit_group = 3;
   */
  unitGroup: EcrConfigUnitGroup;

  /**
   * @generated from field: kss.CompetitorWeight competitor_weight = 4;
   */
  competitorWeight: CompetitorWeight;
};

/**
 * Describes the message kss.CompetitorWeightUpdate.
 * Use `create(CompetitorWeightUpdateSchema)` to create a new message.
 */
export const CompetitorWeightUpdateSchema: GenMessage<CompetitorWeightUpdate> = /*@__PURE__*/
  messageDesc(file_kss, 92);

/**
 * @generated from message kss.GetCompetitorWeightsRequest
 */
export type GetCompetitorWeightsRequest = Message<"kss.GetCompetitorWeightsRequest"> & {
  /**
   * If no site_id is provided, returns all weights
   *
   * @generated from field: optional string site_id = 1;
   */
  siteId?: string | undefined;
};

/**
 * Describes the message kss.GetCompetitorWeightsRequest.
 * Use `create(GetCompetitorWeightsRequestSchema)` to create a new message.
 */
export const GetCompetitorWeightsRequestSchema: GenMessage<GetCompetitorWeightsRequest> = /*@__PURE__*/
  messageDesc(file_kss, 93);

/**
 * @generated from message kss.GetCompetitorWeightsResponse
 */
export type GetCompetitorWeightsResponse = Message<"kss.GetCompetitorWeightsResponse"> & {
  /**
   * @generated from field: repeated kss.CompetitorWeightEntry weights = 1;
   */
  weights: CompetitorWeightEntry[];
};

/**
 * Describes the message kss.GetCompetitorWeightsResponse.
 * Use `create(GetCompetitorWeightsResponseSchema)` to create a new message.
 */
export const GetCompetitorWeightsResponseSchema: GenMessage<GetCompetitorWeightsResponse> = /*@__PURE__*/
  messageDesc(file_kss, 94);

/**
 * @generated from message kss.UpdateCompetitorWeightsRequest
 */
export type UpdateCompetitorWeightsRequest = Message<"kss.UpdateCompetitorWeightsRequest"> & {
  /**
   * @generated from field: repeated kss.CompetitorWeightUpdate to_update = 1;
   */
  toUpdate: CompetitorWeightUpdate[];
};

/**
 * Describes the message kss.UpdateCompetitorWeightsRequest.
 * Use `create(UpdateCompetitorWeightsRequestSchema)` to create a new message.
 */
export const UpdateCompetitorWeightsRequestSchema: GenMessage<UpdateCompetitorWeightsRequest> = /*@__PURE__*/
  messageDesc(file_kss, 95);

/**
 * @generated from message kss.CreateUserRequest
 */
export type CreateUserRequest = Message<"kss.CreateUserRequest"> & {
  /**
   * @generated from field: string fname = 1;
   */
  fname: string;

  /**
   * @generated from field: string lname = 2;
   */
  lname: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: kss.Role role = 4;
   */
  role: Role;
};

/**
 * Describes the message kss.CreateUserRequest.
 * Use `create(CreateUserRequestSchema)` to create a new message.
 */
export const CreateUserRequestSchema: GenMessage<CreateUserRequest> = /*@__PURE__*/
  messageDesc(file_kss, 96);

/**
 * @generated from message kss.UserIdRequest
 */
export type UserIdRequest = Message<"kss.UserIdRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message kss.UserIdRequest.
 * Use `create(UserIdRequestSchema)` to create a new message.
 */
export const UserIdRequestSchema: GenMessage<UserIdRequest> = /*@__PURE__*/
  messageDesc(file_kss, 97);

/**
 * @generated from message kss.ListUsersResponse
 */
export type ListUsersResponse = Message<"kss.ListUsersResponse"> & {
  /**
   * @generated from field: repeated kss.UserRecord users = 1;
   */
  users: UserRecord[];
};

/**
 * Describes the message kss.ListUsersResponse.
 * Use `create(ListUsersResponseSchema)` to create a new message.
 */
export const ListUsersResponseSchema: GenMessage<ListUsersResponse> = /*@__PURE__*/
  messageDesc(file_kss, 98);

/**
 * @generated from message kss.UserRecord
 */
export type UserRecord = Message<"kss.UserRecord"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string fname = 2;
   */
  fname: string;

  /**
   * @generated from field: string lname = 3;
   */
  lname: string;

  /**
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * @generated from field: bool active = 5;
   */
  active: boolean;

  /**
   * @generated from field: repeated kss.Role roles = 7;
   */
  roles: Role[];
};

/**
 * Describes the message kss.UserRecord.
 * Use `create(UserRecordSchema)` to create a new message.
 */
export const UserRecordSchema: GenMessage<UserRecord> = /*@__PURE__*/
  messageDesc(file_kss, 99);

/**
 * @generated from message kss.ChangeUserRoleRequest
 */
export type ChangeUserRoleRequest = Message<"kss.ChangeUserRoleRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: kss.Role new_role = 2;
   */
  newRole: Role;
};

/**
 * Describes the message kss.ChangeUserRoleRequest.
 * Use `create(ChangeUserRoleRequestSchema)` to create a new message.
 */
export const ChangeUserRoleRequestSchema: GenMessage<ChangeUserRoleRequest> = /*@__PURE__*/
  messageDesc(file_kss, 100);

/**
 * @generated from message kss.GetActiveUnitTypePathsResponse
 */
export type GetActiveUnitTypePathsResponse = Message<"kss.GetActiveUnitTypePathsResponse"> & {
  /**
   * @generated from field: repeated string unit_type_paths = 1;
   */
  unitTypePaths: string[];

  /**
   * @generated from field: int64 processing_date = 2;
   */
  processingDate: bigint;
};

/**
 * Describes the message kss.GetActiveUnitTypePathsResponse.
 * Use `create(GetActiveUnitTypePathsResponseSchema)` to create a new message.
 */
export const GetActiveUnitTypePathsResponseSchema: GenMessage<GetActiveUnitTypePathsResponse> = /*@__PURE__*/
  messageDesc(file_kss, 101);

/**
 * @generated from message kss.GetAggregatedDataForPathsRequest
 */
export type GetAggregatedDataForPathsRequest = Message<"kss.GetAggregatedDataForPathsRequest"> & {
  /**
   * @generated from field: repeated string paths = 1;
   */
  paths: string[];
};

/**
 * Describes the message kss.GetAggregatedDataForPathsRequest.
 * Use `create(GetAggregatedDataForPathsRequestSchema)` to create a new message.
 */
export const GetAggregatedDataForPathsRequestSchema: GenMessage<GetAggregatedDataForPathsRequest> = /*@__PURE__*/
  messageDesc(file_kss, 102);

/**
 * @generated from message kss.GetAggregatedDataForPathsResponse
 */
export type GetAggregatedDataForPathsResponse = Message<"kss.GetAggregatedDataForPathsResponse"> & {
  /**
   * @generated from field: map<string, kss.AggregatedData> data = 1;
   */
  data: { [key: string]: AggregatedData };
};

/**
 * Describes the message kss.GetAggregatedDataForPathsResponse.
 * Use `create(GetAggregatedDataForPathsResponseSchema)` to create a new message.
 */
export const GetAggregatedDataForPathsResponseSchema: GenMessage<GetAggregatedDataForPathsResponse> = /*@__PURE__*/
  messageDesc(file_kss, 103);

/**
 * @generated from message kss.VersionInfoResponse
 */
export type VersionInfoResponse = Message<"kss.VersionInfoResponse"> & {
  /**
   * @generated from field: string version = 1;
   */
  version: string;
};

/**
 * Describes the message kss.VersionInfoResponse.
 * Use `create(VersionInfoResponseSchema)` to create a new message.
 */
export const VersionInfoResponseSchema: GenMessage<VersionInfoResponse> = /*@__PURE__*/
  messageDesc(file_kss, 104);

/**
 * @generated from enum kss.SnapshotColumn
 */
export enum SnapshotColumn {
  /**
   * @generated from enum value: total_units = 0;
   */
  total_units = 0,

  /**
   * @generated from enum value: rentable_units = 1;
   */
  rentable_units = 1,

  /**
   * @generated from enum value: rented_units = 2;
   */
  rented_units = 2,

  /**
   * @generated from enum value: rented_units_28d = 3;
   */
  rented_units_28d = 3,

  /**
   * @generated from enum value: reserved_units = 4;
   */
  reserved_units = 4,

  /**
   * @generated from enum value: occupied_units = 5;
   */
  occupied_units = 5,

  /**
   * @generated from enum value: vacant_units = 6;
   */
  vacant_units = 6,

  /**
   * @generated from enum value: move_in_units = 7;
   */
  move_in_units = 7,

  /**
   * @generated from enum value: move_out_units = 8;
   */
  move_out_units = 8,

  /**
   * @generated from enum value: total_sqm = 9;
   */
  total_sqm = 9,

  /**
   * @generated from enum value: rentable_sqm = 10;
   */
  rentable_sqm = 10,

  /**
   * @generated from enum value: rented_sqm = 11;
   */
  rented_sqm = 11,

  /**
   * @generated from enum value: rented_sqm_28d = 12;
   */
  rented_sqm_28d = 12,

  /**
   * @generated from enum value: reserved_sqm = 13;
   */
  reserved_sqm = 13,

  /**
   * @generated from enum value: occupied_sqm = 14;
   */
  occupied_sqm = 14,

  /**
   * @generated from enum value: vacant_sqm = 15;
   */
  vacant_sqm = 15,

  /**
   * @generated from enum value: move_in_sqm = 16;
   */
  move_in_sqm = 16,

  /**
   * @generated from enum value: move_out_sqm = 17;
   */
  move_out_sqm = 17,

  /**
   * @generated from enum value: occupied_rent = 18;
   */
  occupied_rent = 18,

  /**
   * @generated from enum value: occupied_min_rent = 19;
   */
  occupied_min_rent = 19,

  /**
   * @generated from enum value: occupied_max_rent = 20;
   */
  occupied_max_rent = 20,

  /**
   * @generated from enum value: street_rent = 21;
   */
  street_rent = 21,

  /**
   * @generated from enum value: competitor_rent = 22;
   */
  competitor_rent = 22,

  /**
   * @generated from enum value: competitor_min_rent = 23;
   */
  competitor_min_rent = 23,

  /**
   * @generated from enum value: competitor_max_rent = 24;
   */
  competitor_max_rent = 24,

  /**
   * @generated from enum value: vacant_rent = 25;
   */
  vacant_rent = 25,

  /**
   * @generated from enum value: recommended_rent = 26;
   */
  recommended_rent = 26,

  /**
   * @generated from enum value: rule_rent = 27;
   */
  rule_rent = 27,

  /**
   * @generated from enum value: revenue = 28;
   */
  revenue = 28,

  /**
   * @generated from enum value: revenue_1y = 29;
   */
  revenue_1y = 29,

  /**
   * @generated from enum value: length_of_stay_mean = 30;
   */
  length_of_stay_mean = 30,

  /**
   * @generated from enum value: length_of_stay_median = 31;
   */
  length_of_stay_median = 31,

  /**
   * @generated from enum value: length_of_stay_min = 32;
   */
  length_of_stay_min = 32,

  /**
   * @generated from enum value: length_of_stay_max = 33;
   */
  length_of_stay_max = 33,

  /**
   * @generated from enum value: length_of_stay_25p = 34;
   */
  length_of_stay_25p = 34,

  /**
   * @generated from enum value: length_of_stay_75p = 35;
   */
  length_of_stay_75p = 35,

  /**
   * @generated from enum value: days_on_market_mean = 36;
   */
  days_on_market_mean = 36,

  /**
   * @generated from enum value: days_on_market_median = 37;
   */
  days_on_market_median = 37,

  /**
   * @generated from enum value: days_on_market_min = 38;
   */
  days_on_market_min = 38,

  /**
   * @generated from enum value: days_on_market_max = 39;
   */
  days_on_market_max = 39,

  /**
   * @generated from enum value: days_on_market_25p = 40;
   */
  days_on_market_25p = 40,

  /**
   * @generated from enum value: days_on_market_75p = 41;
   */
  days_on_market_75p = 41,

  /**
   * @generated from enum value: revpom = 42;
   */
  revpom = 42,

  /**
   * @generated from enum value: revpam = 43;
   */
  revpam = 43,

  /**
   * @generated from enum value: move_in_rent = 44;
   */
  move_in_rent = 44,

  /**
   * @generated from enum value: move_in_rate = 45;
   */
  move_in_rate = 45,

  /**
   * @generated from enum value: move_out_rent = 46;
   */
  move_out_rent = 46,

  /**
   * @generated from enum value: move_out_rate = 47;
   */
  move_out_rate = 47,

  /**
   * @generated from enum value: occupancy_perc_units = 48;
   */
  occupancy_perc_units = 48,

  /**
   * @generated from enum value: occupancy_perc_units_28d = 49;
   */
  occupancy_perc_units_28d = 49,

  /**
   * @generated from enum value: occupancy_perc_units_1y = 50;
   */
  occupancy_perc_units_1y = 50,

  /**
   * @generated from enum value: occupancy_perc_sqm = 51;
   */
  occupancy_perc_sqm = 51,

  /**
   * @generated from enum value: occupancy_perc_sqm_28d = 52;
   */
  occupancy_perc_sqm_28d = 52,

  /**
   * @generated from enum value: occupancy_perc_sqm_1y = 53;
   */
  occupancy_perc_sqm_1y = 53,

  /**
   * @generated from enum value: repair_units = 54;
   */
  repair_units = 54,

  /**
   * @generated from enum value: repair_sqm = 55;
   */
  repair_sqm = 55,

  /**
   * @generated from enum value: company_units = 56;
   */
  company_units = 56,

  /**
   * @generated from enum value: company_sqm = 57;
   */
  company_sqm = 57,

  /**
   * @generated from enum value: occupied_rate = 58;
   */
  occupied_rate = 58,

  /**
   * @generated from enum value: occupied_min_rate = 59;
   */
  occupied_min_rate = 59,

  /**
   * @generated from enum value: occupied_max_rate = 60;
   */
  occupied_max_rate = 60,

  /**
   * @generated from enum value: competitor_rate = 61;
   */
  competitor_rate = 61,

  /**
   * @generated from enum value: competitor_min_rate = 62;
   */
  competitor_min_rate = 62,

  /**
   * @generated from enum value: competitor_max_rate = 63;
   */
  competitor_max_rate = 63,

  /**
   * @generated from enum value: street_rate = 64;
   */
  street_rate = 64,

  /**
   * @generated from enum value: recommended_rate = 65;
   */
  recommended_rate = 65,

  /**
   * @generated from enum value: rule_rate = 66;
   */
  rule_rate = 66,

  /**
   * @generated from enum value: length_of_stay_7d_mean = 67;
   */
  length_of_stay_7d_mean = 67,

  /**
   * @generated from enum value: length_of_stay_7d_median = 68;
   */
  length_of_stay_7d_median = 68,

  /**
   * @generated from enum value: length_of_stay_7d_min = 69;
   */
  length_of_stay_7d_min = 69,

  /**
   * @generated from enum value: length_of_stay_7d_max = 70;
   */
  length_of_stay_7d_max = 70,

  /**
   * @generated from enum value: length_of_stay_7d_25p = 71;
   */
  length_of_stay_7d_25p = 71,

  /**
   * @generated from enum value: length_of_stay_7d_75p = 72;
   */
  length_of_stay_7d_75p = 72,

  /**
   * @generated from enum value: length_of_stay_28d_mean = 73;
   */
  length_of_stay_28d_mean = 73,

  /**
   * @generated from enum value: length_of_stay_28d_median = 74;
   */
  length_of_stay_28d_median = 74,

  /**
   * @generated from enum value: length_of_stay_28d_min = 75;
   */
  length_of_stay_28d_min = 75,

  /**
   * @generated from enum value: length_of_stay_28d_max = 76;
   */
  length_of_stay_28d_max = 76,

  /**
   * @generated from enum value: length_of_stay_28d_25p = 77;
   */
  length_of_stay_28d_25p = 77,

  /**
   * @generated from enum value: length_of_stay_28d_75p = 78;
   */
  length_of_stay_28d_75p = 78,

  /**
   * @generated from enum value: occupancy_perc_units_7d = 79;
   */
  occupancy_perc_units_7d = 79,

  /**
   * @generated from enum value: occupancy_perc_sqm_7d = 80;
   */
  occupancy_perc_sqm_7d = 80,

  /**
   * @generated from enum value: occupancy_units_7d = 81;
   */
  occupancy_units_7d = 81,

  /**
   * @generated from enum value: occupancy_units_28d = 82;
   */
  occupancy_units_28d = 82,

  /**
   * @generated from enum value: occupancy_units_1y = 83;
   */
  occupancy_units_1y = 83,
}

/**
 * Describes the enum kss.SnapshotColumn.
 */
export const SnapshotColumnSchema: GenEnum<SnapshotColumn> = /*@__PURE__*/
  enumDesc(file_kss, 0);

/**
 * @generated from enum kss.ForecastColumn
 */
export enum ForecastColumn {
  /**
   * @generated from enum value: move_in_4w_exp = 0;
   */
  move_in_4w_exp = 0,

  /**
   * @generated from enum value: move_in_4w_min = 1;
   */
  move_in_4w_min = 1,

  /**
   * @generated from enum value: move_in_4w_max = 2;
   */
  move_in_4w_max = 2,

  /**
   * @generated from enum value: move_in_12m_exp = 3;
   */
  move_in_12m_exp = 3,

  /**
   * @generated from enum value: move_in_12m_min = 4;
   */
  move_in_12m_min = 4,

  /**
   * @generated from enum value: move_in_12m_max = 5;
   */
  move_in_12m_max = 5,

  /**
   * @generated from enum value: move_out_4w_exp = 6;
   */
  move_out_4w_exp = 6,

  /**
   * @generated from enum value: move_out_4w_min = 7;
   */
  move_out_4w_min = 7,

  /**
   * @generated from enum value: move_out_4w_max = 8;
   */
  move_out_4w_max = 8,

  /**
   * @generated from enum value: move_out_12m_exp = 9;
   */
  move_out_12m_exp = 9,

  /**
   * @generated from enum value: move_out_12m_min = 10;
   */
  move_out_12m_min = 10,

  /**
   * @generated from enum value: move_out_12m_max = 11;
   */
  move_out_12m_max = 11,

  /**
   * @generated from enum value: occupancy_4w_exp = 12;
   */
  occupancy_4w_exp = 12,

  /**
   * @generated from enum value: occupancy_4w_min = 13;
   */
  occupancy_4w_min = 13,

  /**
   * @generated from enum value: occupancy_4w_max = 14;
   */
  occupancy_4w_max = 14,

  /**
   * @generated from enum value: occupancy_12m_exp = 15;
   */
  occupancy_12m_exp = 15,

  /**
   * @generated from enum value: occupancy_12m_min = 16;
   */
  occupancy_12m_min = 16,

  /**
   * @generated from enum value: occupancy_12m_max = 17;
   */
  occupancy_12m_max = 17,

  /**
   * @generated from enum value: vacancy_4w_exp = 18;
   */
  vacancy_4w_exp = 18,

  /**
   * @generated from enum value: vacancy_4w_min = 19;
   */
  vacancy_4w_min = 19,

  /**
   * @generated from enum value: vacancy_4w_max = 20;
   */
  vacancy_4w_max = 20,

  /**
   * @generated from enum value: vacancy_12m_exp = 21;
   */
  vacancy_12m_exp = 21,

  /**
   * @generated from enum value: vacancy_12m_min = 22;
   */
  vacancy_12m_min = 22,

  /**
   * @generated from enum value: vacancy_12m_max = 23;
   */
  vacancy_12m_max = 23,
}

/**
 * Describes the enum kss.ForecastColumn.
 */
export const ForecastColumnSchema: GenEnum<ForecastColumn> = /*@__PURE__*/
  enumDesc(file_kss, 1);

/**
 * @generated from enum kss.HistoricalForecastColumn
 */
export enum HistoricalForecastColumn {
  /**
   * @generated from enum value: hist_move_in_4w_exp = 0;
   */
  hist_move_in_4w_exp = 0,

  /**
   * @generated from enum value: hist_move_in_4w_min = 1;
   */
  hist_move_in_4w_min = 1,

  /**
   * @generated from enum value: hist_move_in_4w_max = 2;
   */
  hist_move_in_4w_max = 2,

  /**
   * @generated from enum value: hist_move_in_12m_exp = 3;
   */
  hist_move_in_12m_exp = 3,

  /**
   * @generated from enum value: hist_move_in_12m_min = 4;
   */
  hist_move_in_12m_min = 4,

  /**
   * @generated from enum value: hist_move_in_12m_max = 5;
   */
  hist_move_in_12m_max = 5,

  /**
   * @generated from enum value: hist_move_out_4w_exp = 6;
   */
  hist_move_out_4w_exp = 6,

  /**
   * @generated from enum value: hist_move_out_4w_min = 7;
   */
  hist_move_out_4w_min = 7,

  /**
   * @generated from enum value: hist_move_out_4w_max = 8;
   */
  hist_move_out_4w_max = 8,

  /**
   * @generated from enum value: hist_move_out_12m_exp = 9;
   */
  hist_move_out_12m_exp = 9,

  /**
   * @generated from enum value: hist_move_out_12m_min = 10;
   */
  hist_move_out_12m_min = 10,

  /**
   * @generated from enum value: hist_move_out_12m_max = 11;
   */
  hist_move_out_12m_max = 11,

  /**
   * @generated from enum value: hist_occupancy_4w_exp = 12;
   */
  hist_occupancy_4w_exp = 12,

  /**
   * @generated from enum value: hist_occupancy_4w_min = 13;
   */
  hist_occupancy_4w_min = 13,

  /**
   * @generated from enum value: hist_occupancy_4w_max = 14;
   */
  hist_occupancy_4w_max = 14,

  /**
   * @generated from enum value: hist_occupancy_12m_exp = 15;
   */
  hist_occupancy_12m_exp = 15,

  /**
   * @generated from enum value: hist_occupancy_12m_min = 16;
   */
  hist_occupancy_12m_min = 16,

  /**
   * @generated from enum value: hist_occupancy_12m_max = 17;
   */
  hist_occupancy_12m_max = 17,

  /**
   * @generated from enum value: hist_vacancy_4w_exp = 18;
   */
  hist_vacancy_4w_exp = 18,

  /**
   * @generated from enum value: hist_vacancy_4w_min = 19;
   */
  hist_vacancy_4w_min = 19,

  /**
   * @generated from enum value: hist_vacancy_4w_max = 20;
   */
  hist_vacancy_4w_max = 20,

  /**
   * @generated from enum value: hist_vacancy_12m_exp = 21;
   */
  hist_vacancy_12m_exp = 21,

  /**
   * @generated from enum value: hist_vacancy_12m_min = 22;
   */
  hist_vacancy_12m_min = 22,

  /**
   * @generated from enum value: hist_vacancy_12m_max = 23;
   */
  hist_vacancy_12m_max = 23,
}

/**
 * Describes the enum kss.HistoricalForecastColumn.
 */
export const HistoricalForecastColumnSchema: GenEnum<HistoricalForecastColumn> = /*@__PURE__*/
  enumDesc(file_kss, 2);

/**
 * @generated from enum kss.WtfType
 */
export enum WtfType {
  /**
   * @generated from enum value: ICU = 0;
   */
  ICU = 0,

  /**
   * @generated from enum value: ACT = 1;
   */
  ACT = 1,

  /**
   * @generated from enum value: WATCH = 2;
   */
  WATCH = 2,

  /**
   * @generated from enum value: NONE = 3;
   */
  NONE = 3,

  /**
   * @generated from enum value: MAINTAIN = 4;
   */
  MAINTAIN = 4,

  /**
   * MISSING = 6;
   * OUT_OF_BOUNDS = 7;
   *
   * @generated from enum value: PUSH = 5;
   */
  PUSH = 5,
}

/**
 * Describes the enum kss.WtfType.
 */
export const WtfTypeSchema: GenEnum<WtfType> = /*@__PURE__*/
  enumDesc(file_kss, 3);

/**
 * @generated from enum kss.PriceChangeSource
 */
export enum PriceChangeSource {
  /**
   * @generated from enum value: CURRENT = 0;
   */
  CURRENT = 0,

  /**
   * @generated from enum value: RECOMMENDED = 1;
   */
  RECOMMENDED = 1,

  /**
   * @generated from enum value: RULE_BASED = 2;
   */
  RULE_BASED = 2,

  /**
   * @generated from enum value: MANUAL = 3;
   */
  MANUAL = 3,
}

/**
 * Describes the enum kss.PriceChangeSource.
 */
export const PriceChangeSourceSchema: GenEnum<PriceChangeSource> = /*@__PURE__*/
  enumDesc(file_kss, 4);

/**
 * @generated from enum kss.PriceChangeStatus
 */
export enum PriceChangeStatus {
  /**
   * @generated from enum value: UNDECIDED = 0;
   */
  UNDECIDED = 0,

  /**
   * @generated from enum value: APPROVED = 1;
   */
  APPROVED = 1,

  /**
   * @generated from enum value: REJECTED = 2;
   */
  REJECTED = 2,

  /**
   * @generated from enum value: SENT_TO_STORMAN = 3;
   */
  SENT_TO_STORMAN = 3,

  /**
   * @generated from enum value: ARCHIVED = 4;
   */
  ARCHIVED = 4,

  /**
   * @generated from enum value: SENT_TO_STORMAN_NOK = 5;
   */
  SENT_TO_STORMAN_NOK = 5,

  /**
   * @generated from enum value: NOT_WHITELISTED = 6;
   */
  NOT_WHITELISTED = 6,
}

/**
 * Describes the enum kss.PriceChangeStatus.
 */
export const PriceChangeStatusSchema: GenEnum<PriceChangeStatus> = /*@__PURE__*/
  enumDesc(file_kss, 5);

/**
 * @generated from enum kss.WatchResponseType
 */
export enum WatchResponseType {
  /**
   * @generated from enum value: ping = 0;
   */
  ping = 0,

  /**
   * @generated from enum value: response = 1;
   */
  response = 1,
}

/**
 * Describes the enum kss.WatchResponseType.
 */
export const WatchResponseTypeSchema: GenEnum<WatchResponseType> = /*@__PURE__*/
  enumDesc(file_kss, 6);

/**
 * @generated from enum kss.PipelineStatus
 */
export enum PipelineStatus {
  /**
   * @generated from enum value: not_started = 0;
   */
  not_started = 0,

  /**
   * @generated from enum value: started = 1;
   */
  started = 1,

  /**
   * @generated from enum value: succeeded = 2;
   */
  succeeded = 2,

  /**
   * @generated from enum value: failed = 3;
   */
  failed = 3,
}

/**
 * Describes the enum kss.PipelineStatus.
 */
export const PipelineStatusSchema: GenEnum<PipelineStatus> = /*@__PURE__*/
  enumDesc(file_kss, 7);

/**
 * @generated from enum kss.RentalPriceChoice
 */
export enum RentalPriceChoice {
  /**
   * @generated from enum value: RECOMMENDATION = 0;
   */
  RECOMMENDATION = 0,

  /**
   * @generated from enum value: OVERRIDE = 1;
   */
  OVERRIDE = 1,

  /**
   * @generated from enum value: CURRENT_PRICE = 2;
   */
  CURRENT_PRICE = 2,
}

/**
 * Describes the enum kss.RentalPriceChoice.
 */
export const RentalPriceChoiceSchema: GenEnum<RentalPriceChoice> = /*@__PURE__*/
  enumDesc(file_kss, 8);

/**
 * @generated from enum kss.EcrConfigUnitGroup
 */
export enum EcrConfigUnitGroup {
  /**
   * @generated from enum value: ALL = 0;
   */
  ALL = 0,

  /**
   * @generated from enum value: S_3 = 2;
   */
  S_3 = 2,

  /**
   * @generated from enum value: S_7 = 3;
   */
  S_7 = 3,

  /**
   * @generated from enum value: S_11 = 4;
   */
  S_11 = 4,

  /**
   * @generated from enum value: S_15 = 5;
   */
  S_15 = 5,

  /**
   * @generated from enum value: S_22 = 6;
   */
  S_22 = 6,

  /**
   * @generated from enum value: S_48 = 7;
   */
  S_48 = 7,

  /**
   * @generated from enum value: S_ES = 8;
   */
  S_ES = 8,

  /**
   * @generated from enum value: LCK = 9;
   */
  LCK = 9,

  /**
   * @generated from enum value: PRK = 10;
   */
  PRK = 10,

  /**
   * @generated from enum value: GUN = 11;
   */
  GUN = 11,

  /**
   * @generated from enum value: DB = 12;
   */
  DB = 12,

  /**
   * @generated from enum value: WIN_1 = 13;
   */
  WIN_1 = 13,

  /**
   * @generated from enum value: WIN_2 = 14;
   */
  WIN_2 = 14,

  /**
   * @generated from enum value: WIN_3 = 15;
   */
  WIN_3 = 15,
}

/**
 * Describes the enum kss.EcrConfigUnitGroup.
 */
export const EcrConfigUnitGroupSchema: GenEnum<EcrConfigUnitGroup> = /*@__PURE__*/
  enumDesc(file_kss, 9);

/**
 * @generated from enum kss.DayOfWeek
 */
export enum DayOfWeek {
  /**
   * @generated from enum value: Monday = 0;
   */
  Monday = 0,

  /**
   * @generated from enum value: Tuesday = 1;
   */
  Tuesday = 1,

  /**
   * @generated from enum value: Wednesday = 2;
   */
  Wednesday = 2,

  /**
   * @generated from enum value: Thursday = 3;
   */
  Thursday = 3,

  /**
   * @generated from enum value: Friday = 4;
   */
  Friday = 4,

  /**
   * @generated from enum value: Saturday = 5;
   */
  Saturday = 5,

  /**
   * @generated from enum value: Sunday = 6;
   */
  Sunday = 6,
}

/**
 * Describes the enum kss.DayOfWeek.
 */
export const DayOfWeekSchema: GenEnum<DayOfWeek> = /*@__PURE__*/
  enumDesc(file_kss, 10);

/**
 * @generated from enum kss.CompetitorWeight
 */
export enum CompetitorWeight {
  /**
   * @generated from enum value: None = 0;
   */
  None = 0,

  /**
   * @generated from enum value: low = 1;
   */
  low = 1,

  /**
   * @generated from enum value: medium = 2;
   */
  medium = 2,

  /**
   * @generated from enum value: high = 3;
   */
  high = 3,
}

/**
 * Describes the enum kss.CompetitorWeight.
 */
export const CompetitorWeightSchema: GenEnum<CompetitorWeight> = /*@__PURE__*/
  enumDesc(file_kss, 11);

/**
 * @generated from enum kss.Role
 */
export enum Role {
  /**
   * @generated from enum value: ADMIN = 0;
   */
  ADMIN = 0,

  /**
   * @generated from enum value: MANAGER = 1;
   */
  MANAGER = 1,

  /**
   * @generated from enum value: USER = 2;
   */
  USER = 2,
}

/**
 * Describes the enum kss.Role.
 */
export const RoleSchema: GenEnum<Role> = /*@__PURE__*/
  enumDesc(file_kss, 12);

/**
 * @generated from service kss.Streamline
 */
export const Streamline: GenService<{
  /**
   * @generated from rpc kss.Streamline.Check
   */
  check: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof EmptySchema;
  },
  /**
   * clear the app cache
   *
   * @generated from rpc kss.Streamline.clearCache
   */
  clearCache: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc kss.Streamline.checkValidity
   */
  checkValidity: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ValidityResponseSchema;
  },
  /**
   * get for a give prefix all children paths (recursively)
   *
   * @generated from rpc kss.Streamline.getAllAggregatedData
   */
  getAllAggregatedData: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof AllAggregatedDataResponseSchema;
  },
  /**
   * get a site by site id
   *
   * @generated from rpc kss.Streamline.getSite
   */
  getSite: {
    methodKind: "unary";
    input: typeof SiteRequestSchema;
    output: typeof SiteResponseSchema;
  },
  /**
   * Gets all the site names
   *
   * @generated from rpc kss.Streamline.getSiteNames
   */
  getSiteNames: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof SiteNamesResponseSchema;
  },
  /**
   * Gets all whitelisted sites
   *
   * @generated from rpc kss.Streamline.getSiteWhitelist
   */
  getSiteWhitelist: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof SiteWhitelistResponseSchema;
  },
  /**
   * Gets all the unit_type area values as a map
   *
   * @generated from rpc kss.Streamline.getUnitTypeAreas
   */
  getUnitTypeAreas: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof UnitTypeAreasResponseSchema;
  },
  /**
   * get unit types by any  filter (site_id, unit_group, unit_type_id)
   *
   * @generated from rpc kss.Streamline.getUnitTypes
   */
  getUnitTypes: {
    methodKind: "unary";
    input: typeof UnitTypesRequestSchema;
    output: typeof UnitTypesResponseSchema;
  },
  /**
   * Returns an array of timeseries values from the snapshot table
   * for the given path and column name. 
   *
   * @generated from rpc kss.Streamline.getTimeseries
   */
  getTimeseries: {
    methodKind: "unary";
    input: typeof GetTimeseriesRequestSchema;
    output: typeof GetTimeseriesResponseSchema;
  },
  /**
   * Returns a map of key -> Timeseries for Snapshots, Forecast and Historical Forecasts respectively
   *
   * @generated from rpc kss.Streamline.getManySnapshots
   */
  getManySnapshots: {
    methodKind: "unary";
    input: typeof GetManySnapshotRequestSchema;
    output: typeof GetManyResponseSchema;
  },
  /**
   * @generated from rpc kss.Streamline.getManyForecasts
   */
  getManyForecasts: {
    methodKind: "unary";
    input: typeof GetManyForecastRequestSchema;
    output: typeof GetManyResponseSchema;
  },
  /**
   * @generated from rpc kss.Streamline.getManyHistoricalForecasts
   */
  getManyHistoricalForecasts: {
    methodKind: "unary";
    input: typeof GetManyHistoricalForecastRequestSchema;
    output: typeof GetManyResponseSchema;
  },
  /**
   * Returns the WTF objects based on the requested wtf type. 
   *
   * @generated from rpc kss.Streamline.getWtf
   */
  getWtf: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof WtfResponseSchema;
  },
  /**
   * Returns the GEO data for the site and competitor.
   *
   * @generated from rpc kss.Streamline.getSiteGeo
   */
  getSiteGeo: {
    methodKind: "unary";
    input: typeof SiteGeoRequestSchema;
    output: typeof SiteGeoResponseSchema;
  },
  /**
   * Provides all the unit type level price changes
   *
   * @generated from rpc kss.Streamline.getPriceChanges
   */
  getPriceChanges: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof PriceChangeResponseSchema;
  },
  /**
   * Watches for changes in price changes table
   *
   * @generated from rpc kss.Streamline.watchPriceChanges
   */
  watchPriceChanges: {
    methodKind: "server_streaming";
    input: typeof AppUserSchema;
    output: typeof WatchPriceChangesResponseSchema;
  },
  /**
   * Allows for the insertion/updating of price changes based on the user's decision.
   *
   * @generated from rpc kss.Streamline.updatePriceChanges
   */
  updatePriceChanges: {
    methodKind: "unary";
    input: typeof UpdatePriceChangesRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Returns the most flags for a given path.
   *
   * @generated from rpc kss.Streamline.getFlags
   */
  getFlags: {
    methodKind: "unary";
    input: typeof GetFlagsRequestSchema;
    output: typeof GetFlagsResponseSchema;
  },
  /**
   * Returns the most recent flags for a list of paths.
   *
   * @generated from rpc kss.Streamline.getManyFlags
   */
  getManyFlags: {
    methodKind: "unary";
    input: typeof GetManyFlagsRequestSchema;
    output: typeof GetManyFlagsResponseSchema;
  },
  /**
   * Returns the current pipeline status for the app.
   *
   * @generated from rpc kss.Streamline.getPipelineStatus
   */
  getPipelineStatus: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof GetPipelineStatusResponseSchema;
  },
  /**
   * Forces the deploy operation from the DB to storman. ONLY FOR TEST ENV. 
   *
   * @generated from rpc kss.Streamline.forceDeployToStorman
   */
  forceDeployToStorman: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof EmptySchema;
  },
  /**
   * Set of calls related to Wtf
   *
   * @generated from rpc kss.Streamline.getWtfInputs
   */
  getWtfInputs: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof GetWtfInputsResponseSchema;
  },
  /**
   * @generated from rpc kss.Streamline.getWtfConfigurations
   */
  getWtfConfigurations: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof GetWtfConfigurationsResponseSchema;
  },
  /**
   * @generated from rpc kss.Streamline.createWtfConfiguration
   */
  createWtfConfiguration: {
    methodKind: "unary";
    input: typeof CreateWtfConfigurationRequestSchema;
    output: typeof CreateWtfConfigurationResponseSchema;
  },
  /**
   * @generated from rpc kss.Streamline.updateWtfConfiguration
   */
  updateWtfConfiguration: {
    methodKind: "unary";
    input: typeof UpdateWtfConfigurationRequestSchema;
    output: typeof UpdateWtfConfigurationResponseSchema;
  },
  /**
   * @generated from rpc kss.Streamline.archiveWtfConfiguration
   */
  archiveWtfConfiguration: {
    methodKind: "unary";
    input: typeof ArchiveWtfConfigurationRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc kss.Streamline.activateWtfConfiguration
   */
  activateWtfConfiguration: {
    methodKind: "unary";
    input: typeof ActivateWtfConfigurationRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc kss.Streamline.evaluateWtfConfiguration
   */
  evaluateWtfConfiguration: {
    methodKind: "unary";
    input: typeof EvaluateWtfConfigurationRequestSchema;
    output: typeof EvaluateWtfConfigurationResponseSchema;
  },
  /**
   * @generated from rpc kss.Streamline.executeWtfConfiguration
   */
  executeWtfConfiguration: {
    methodKind: "unary";
    input: typeof ExecuteWtfConfigurationRequestSchema;
    output: typeof ExecuteWtfConfigurationResponseSchema;
  },
  /**
   * @generated from rpc kss.Streamline.validateWtfConfiguration
   */
  validateWtfConfiguration: {
    methodKind: "unary";
    input: typeof ValidateWtfConfigurationRequestSchema;
    output: typeof ValidateWtfConfigurationResponseSchema;
  },
  /**
   * @generated from rpc kss.Streamline.validateWtfCompoundInput
   */
  validateWtfCompoundInput: {
    methodKind: "unary";
    input: typeof ValidateWtfCompoundInputRequestSchema;
    output: typeof ValidateWtfCompoundInputResponseSchema;
  },
  /**
   * Calls for Rentals
   *
   * @generated from rpc kss.Streamline.getUnitRentals
   */
  getUnitRentals: {
    methodKind: "unary";
    input: typeof UnitRentalsRequestSchema;
    output: typeof UnitRentalsResponseSchema;
  },
  /**
   * @generated from rpc kss.Streamline.getAllUnitRentalPriceChanges
   */
  getAllUnitRentalPriceChanges: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof GetAllUnitRentalPriceChangesResponseSchema;
  },
  /**
   * @generated from rpc kss.Streamline.getRentalPriceChange
   */
  getRentalPriceChange: {
    methodKind: "unary";
    input: typeof GetRentalPriceChangeRequestSchema;
    output: typeof RentalPriceChangeSchema;
  },
  /**
   * @generated from rpc kss.Streamline.updateRentalPriceChanges
   */
  updateRentalPriceChanges: {
    methodKind: "unary";
    input: typeof UpdateRentalPriceChangesRequestSchema;
    output: typeof UpdateRentalPriceChangesResponseSchema;
  },
  /**
   * @generated from rpc kss.Streamline.getRentalPriceHistory
   */
  getRentalPriceHistory: {
    methodKind: "unary";
    input: typeof GetRentalPriceHistoryRequestSchema;
    output: typeof GetRentalPriceHistoryResponseSchema;
  },
  /**
   * Calls for ECR config
   *
   * @generated from rpc kss.Streamline.getGlobalEcrConfig
   */
  getGlobalEcrConfig: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof GlobalEcrConfigSchema;
  },
  /**
   * @generated from rpc kss.Streamline.updateGlobalEcrConfig
   */
  updateGlobalEcrConfig: {
    methodKind: "unary";
    input: typeof GlobalEcrConfigSchema;
    output: typeof GlobalEcrConfigSchema;
  },
  /**
   * @generated from rpc kss.Streamline.getExclusionEcrConfig
   */
  getExclusionEcrConfig: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ExclusionEcrConfigSchema;
  },
  /**
   * @generated from rpc kss.Streamline.updateExclusionEcrConfig
   */
  updateExclusionEcrConfig: {
    methodKind: "unary";
    input: typeof ExclusionEcrConfigSchema;
    output: typeof ExclusionEcrConfigSchema;
  },
  /**
   * @generated from rpc kss.Streamline.getTierBoundEcrConfig
   */
  getTierBoundEcrConfig: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof TierBoundEcrConfigSchema;
  },
  /**
   * @generated from rpc kss.Streamline.updateTierBoundEcrConfig
   */
  updateTierBoundEcrConfig: {
    methodKind: "unary";
    input: typeof TierBoundEcrConfigSchema;
    output: typeof TierBoundEcrConfigSchema;
  },
  /**
   * Competitor Weighting
   *
   * @generated from rpc kss.Streamline.getCompetitorWeights
   */
  getCompetitorWeights: {
    methodKind: "unary";
    input: typeof GetCompetitorWeightsRequestSchema;
    output: typeof GetCompetitorWeightsResponseSchema;
  },
  /**
   * @generated from rpc kss.Streamline.updateCompetitorWeights
   */
  updateCompetitorWeights: {
    methodKind: "unary";
    input: typeof UpdateCompetitorWeightsRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * User Management  
   *
   * @generated from rpc kss.Streamline.createUser
   */
  createUser: {
    methodKind: "unary";
    input: typeof CreateUserRequestSchema;
    output: typeof UserRecordSchema;
  },
  /**
   * @generated from rpc kss.Streamline.disableUser
   */
  disableUser: {
    methodKind: "unary";
    input: typeof UserIdRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc kss.Streamline.enableUser
   */
  enableUser: {
    methodKind: "unary";
    input: typeof UserIdRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc kss.Streamline.forcePasswordReset
   */
  forcePasswordReset: {
    methodKind: "unary";
    input: typeof UserIdRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc kss.Streamline.listUsers
   */
  listUsers: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListUsersResponseSchema;
  },
  /**
   * @generated from rpc kss.Streamline.changeUserRole
   */
  changeUserRole: {
    methodKind: "unary";
    input: typeof ChangeUserRoleRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc kss.Streamline.ResetUserMFA
   */
  resetUserMFA: {
    methodKind: "unary";
    input: typeof UserIdRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * For API speedups
   *
   * @generated from rpc kss.Streamline.getActiveUnitTypePaths
   */
  getActiveUnitTypePaths: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof GetActiveUnitTypePathsResponseSchema;
  },
  /**
   * @generated from rpc kss.Streamline.getAggregatedDataForPaths
   */
  getAggregatedDataForPaths: {
    methodKind: "unary";
    input: typeof GetAggregatedDataForPathsRequestSchema;
    output: typeof GetAggregatedDataForPathsResponseSchema;
  },
  /**
   * Get application version and changelog
   *
   * @generated from rpc kss.Streamline.getVersionInfo
   */
  getVersionInfo: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof VersionInfoResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_kss, 0);

